var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Accepts a term for customer
 * @summary customers/{customerId}/acceptedTerms
 */
export var createCustomerAcceptedTerm = function (client, customerId, globalCustomersAcceptedTermDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/acceptedTerms"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersAcceptedTermDto,
    }, options);
};
/**
 * Change password based on the old one.
 * @summary accounts/my/changePassword
 */
export var updateAccountsMyChangePassword = function (client, globalAccountsChangePasswordDto, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/accounts/my/changePassword",
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalAccountsChangePasswordDto,
        params: params,
    }, options);
};
/**
 * Retrieves the account info for account with given login string.
 * @summary accounts/my
 */
export var getAccountsMy = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/accounts/my", method: 'get', headers: headers, params: params }, options);
};
/**
 * First step of password reset. Send temporary password to the user over notification channel(s)
 * @summary accounts/my/sendTemporaryPassword
 */
export var createAccountsMySendTemporaryPassword = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/accounts/my/sendTemporaryPassword", method: 'post', headers: headers, params: params }, options);
};
/**
 * Second step of password reset. Reset password based on temporary and new password.
 * @summary accounts/my/resetPassword
 */
export var updateAccountsMyResetPassword = function (client, globalAccountsResetPasswordDto, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/accounts/my/resetPassword",
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalAccountsResetPasswordDto,
        params: params,
    }, options);
};
/**
 * Returns metadata for change password endpoint
 * @summary accounts/changePasswordMetadata
 */
export var getAccountsChangePasswordMetadata = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/accounts/changePasswordMetadata", method: 'get', headers: headers }, options);
};
/**
 * Provides set of permissions based on identity in access token
 * @summary accounts/my/permissions
 */
export var getAccountsMyPermissions = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/accounts/my/permissions", method: 'get', headers: headers }, options);
};
/**
 * GET: Returns information about customer activation
 * @summary customers/{customerId}/activationRequest
 */
export var getCustomerActivationRequest = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/activationRequest"), method: 'get', headers: headers }, options);
};
/**
 * PUT: Requests resending of activation code for given customer
 * @summary customers/{customerId}/activationRequest
 */
export var updateCustomerActivationRequest = function (client, customerId, globalCustomersActivationRequestDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/activationRequest"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersActivationRequestDto,
    }, options);
};
/**
 * GET: Gets customer addresses
 * @summary customers/{customerId}/addresses
 */
export var getCustomerAddresses = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/addresses"), method: 'get', headers: headers }, options);
};
/**
 * POST: Creates customer address
 * @summary customers/{customerId}/addresses
 */
export var createCustomerAddress = function (client, customerId, globalCustomersAddressDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/addresses"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersAddressDtoBody,
    }, options);
};
/**
 * PUT: Updates customer address
 * @summary customers/{customerId}/addresses/{addressId}
 */
export var updateCustomerAddress = function (client, customerId, addressId, globalCustomersAddressDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/addresses/").concat(addressId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersAddressDtoBody,
    }, options);
};
/**
 * DELETE: Remove customer address identified by id
 * @summary customers/{customerId}/addresses/{addressId}
 */
export var deleteCustomerAddress = function (client, customerId, addressId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/addresses/").concat(addressId), method: 'delete', headers: headers }, options);
};
/**
 * GET: Gets metadata information for address endpoints of the customer with given customer id
 * @summary customers/{customerId}/addressesMetadata
 */
export var getCustomerAddressesMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/addressesMetadata"), method: 'get', headers: headers }, options);
};
/**
 * GET: Returns options for address formatting
 * @summary addressFormats
 */
export var getAddressFormats = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/addressFormats", method: 'get', headers: headers }, options);
};
/**
 * GET: Returns specific option for address formatting
 * @summary addressFormats/{type}
 */
export var getAddressFormat = function (client, type, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/addressFormats/".concat(type), method: 'get', headers: headers }, options);
};
/**
 * GET: Returns the available payment methods
 * @summary payments/{onlinePaymentId}/paymentProviders/adyen/paymentMethods
 */
export var getPaymentPaymentProvidersAdyenPaymentMethods = function (client, onlinePaymentId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/payments/".concat(onlinePaymentId, "/paymentProviders/adyen/paymentMethods"),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * POST: Initiates payment
 * @summary payments/{onlinePaymentId}/paymentProviders/adyen/payments
 */
export var createPaymentPaymentProvidersAdyenPayment = function (client, onlinePaymentId, globalPaymentsAdyenPaymentRequestDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/payments/".concat(onlinePaymentId, "/paymentProviders/adyen/payments"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalPaymentsAdyenPaymentRequestDto,
    }, options);
};
/**
 * POST: Sends payment details when a customer is required to perform additional actions
 * @summary payments/{onlinePaymentId}/paymentProviders/adyen/paymentDetails
 */
export var createPaymentPaymentProvidersAdyenPaymentDetail = function (client, onlinePaymentId, createPaymentPaymentProvidersAdyenPaymentDetailBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/payments/".concat(onlinePaymentId, "/paymentProviders/adyen/paymentDetails"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: createPaymentPaymentProvidersAdyenPaymentDetailBody,
    }, options);
};
/**
 * GET: Returns client credentials for FE component
 * @summary payments/{onlinePaymentId}/paymentProviders/adyen/clientCredentials
 */
export var getPaymentPaymentProvidersAdyenClientCredentials = function (client, onlinePaymentId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/payments/".concat(onlinePaymentId, "/paymentProviders/adyen/clientCredentials"),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * POST: Adyen Checkout/Recurring API - Disables stored payment details to stop charging a shopper with this particular recurring detail ID
 * @summary customers/{customerId}/paymentProviders/adyen/contractDisableRequest
 */
export var createCustomerPaymentProvidersAdyenContractDisableRequest = function (client, customerId, globalCustomersAdyenContractDisableRequestDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/paymentProviders/adyen/contractDisableRequest"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersAdyenContractDisableRequestDto,
    }, options);
};
/**
 * GET: Returns analytics data of registration with given ID
 * @summary customerRegistrations/{registrationId}/analytics
 */
export var getCustomerRegistrationAnalytics = function (client, registrationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customerRegistrations/".concat(registrationId, "/analytics"), method: 'get', headers: headers }, options);
};
/**
 * GET: Gets the customer approvals of the customer for given customer id
 * @summary customers/{customerId}/approval
 */
export var getCustomerApproval = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/approval"), method: 'get', headers: headers }, options);
};
/**
 * PUT: Update the customer approvals of the customer for given customer id
 * @summary customers/{customerId}/approval
 */
export var updateCustomerApproval = function (client, customerId, globalSharedApprovalDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/approval"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalSharedApprovalDto,
    }, options);
};
/**
 * GET: Gets metadata information for approval endpoints of the customer with given customer id
 * @summary customers/{customerId}/approvalMetadata
 */
export var getCustomerApprovalMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/approvalMetadata"), method: 'get', headers: headers }, options);
};
/**
 * Gets product(s) ATP
 * @summary atpClusters/{atpClusterId}/atps/{itemCode}
 */
export var getAtpClusterAtp = function (client, atpClusterId, itemCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/atpClusters/".concat(atpClusterId, "/atps/").concat(itemCode), method: 'get', headers: headers }, options);
};
/**
 * Gets product(s) ATP
 * @summary atpClusters/{atpClusterId}/atps
 */
export var getAtpClusterAtps = function (client, atpClusterId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/atpClusters/".concat(atpClusterId, "/atps"), method: 'get', headers: headers, params: params }, options);
};
/**
 * Gets ATP cluster
 * @summary atpClusters/{atpClusterId}
 */
export var getAtpCluster = function (client, atpClusterId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/atpClusters/".concat(atpClusterId), method: 'get', headers: headers }, options);
};
/**
 * Find ATP cluster based on delivery channel and/or delivery address
 * @summary atpClusters
 */
export var getAtpClusters = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/atpClusters", method: 'get', headers: headers, params: params }, options);
};
/**
 * Get autoship configuration
 * @summary customers/{customerId}/autoshipConfiguration
 */
export var getCustomerAutoshipConfiguration = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/autoshipConfiguration"), method: 'get', headers: headers }, options);
};
/**
 * Get autoship availability per specified product/item
 * @summary customers/{customerId}/autoshipAvailabilities
 */
export var getCustomerAutoshipAvailabilities = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/autoshipAvailabilities"), method: 'get', headers: headers, params: params }, options);
};
/**
 * Get autoship types.
Optionally filtered by product contained in subscription.
 * @summary customers/{customerId}/autoshipTypes
 */
export var getCustomerAutoshipTypes = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/autoshipTypes"), method: 'get', headers: headers, params: params }, options);
};
/**
 * Returns URLs and titles of legal info articles.
 * @summary customers/{customerId}/autoshipLegalArticles
 */
export var getCustomerAutoshipLegalArticles = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/autoshipLegalArticles"), method: 'get', headers: headers }, options);
};
/**
 * Post autoship instruction.
Depends on instruction status (Pending/Finished) provides only validation or also creates new autoship subscription if Finished
 * @summary customers/{customerId}/autoshipInstructions
 */
export var createCustomerAutoshipInstruction = function (client, customerId, globalCustomersAutoshipInstructionDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/autoshipInstructions"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersAutoshipInstructionDto,
    }, options);
};
/**
 * GET: Provides information about concept availability
 * @summary concepts/{conceptCode}/availability
 */
export var getConceptAvailability = function (client, conceptCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/concepts/".concat(conceptCode, "/availability"), method: 'get', headers: headers }, options);
};
/**
 * Get availability of concepts for specific customer
 * @summary customers/{customerId}/concepts/availabilities
 */
export var getCustomerConceptsAvailabilities = function (client, customerId, globalConceptsAvailabilitiesQueryDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/concepts/availabilities"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalConceptsAvailabilitiesQueryDtoBody,
    }, options);
};
/**
 * Get availability of concepts
 * @summary concepts/availabilities
 */
export var getConceptsAvailabilities = function (client, globalConceptsAvailabilitiesQueryDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/concepts/availabilities",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalConceptsAvailabilitiesQueryDtoBody,
    }, options);
};
/**
 * GET: Provides information about concept availability
 * @summary customers/{customerId}/concepts/{conceptCode}/availability
 */
export var getCustomerConceptAvailability = function (client, customerId, conceptCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/concepts/").concat(conceptCode, "/availability"),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * Get availability of product for specific customer
 * @summary customers/{customerId}/products/{productCode}/availability
 */
export var getCustomerProductAvailability = function (client, customerId, productCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/products/").concat(productCode, "/availability"),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * Get availability of product
 * @summary products/{productCode}/availability
 */
export var getProductAvailability = function (client, productCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/products/".concat(productCode, "/availability"), method: 'get', headers: headers }, options);
};
/**
 * Get products availability for specified collection of products
 * @summary products/availability
 */
export var getProductsAvailability = function (client, globalProductsProductAvailabilityQueryDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/products/availability",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalProductsProductAvailabilityQueryDtoBody,
    }, options);
};
/**
 * Get products Availability for specified customer and specified collection of products
 * @summary customer/{customerId}/products/availability
 */
export var getCustomerProductsAvailability = function (client, customerId, globalProductsProductAvailabilityQueryDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customer/".concat(customerId, "/products/availability"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalProductsProductAvailabilityQueryDtoBody,
    }, options);
};
/**
 * Get information about possibility to subscribe for BIS notifications for each product requested by productCodes.
 * @summary backInStockNotifications
 */
export var getBackInStockNotifications = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/backInStockNotifications", method: 'get', headers: headers, params: params }, options);
};
/**
 * Stores passed by parameter notificationData information so user receives BIS notifications.
 * @summary backInStockNotificationSubscriptions
 */
export var createBackInStockNotificationSubscription = function (client, globalBackInStockNotificationsBackInStockNotificationSubscriptionDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/backInStockNotificationSubscriptions",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalBackInStockNotificationsBackInStockNotificationSubscriptionDtoBody,
    }, options);
};
/**
 * Get configuration for back in stock notifications.
 * @summary backInStockNotificationsConfiguration
 */
export var getBackInStockNotificationsConfiguration = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/backInStockNotificationsConfiguration", method: 'get', headers: headers }, options);
};
/**
 * Get information about possibility to subscribe for BIS notifications for each product requested by productCodes.
 * @summary customers/{customerId}/backInStockNotifications
 */
export var getCustomerBackInStockNotifications = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/backInStockNotifications"), method: 'get', headers: headers, params: params }, options);
};
/**
 * Stores passed by parameter notificationData information so user receives BIS notifications.
 * @summary customers/{customerId}/backInStockNotificationSubscriptions
 */
export var createCustomerBackInStockNotificationSubscription = function (client, customerId, globalBackInStockNotificationsBackInStockNotificationSubscriptionDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/backInStockNotificationSubscriptions"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalBackInStockNotificationsBackInStockNotificationSubscriptionDtoBody,
    }, options);
};
/**
 * GET: Gets bank account approvals
 * @summary customers/{customerId}/bankAccountApprovals
 */
export var getCustomerBankAccountApprovals = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/bankAccountApprovals"), method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Gets customer bank accounts
 * @summary customers/{customerId}/bankAccounts
 */
export var getCustomerBankAccounts = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/bankAccounts"), method: 'get', headers: headers, params: params }, options);
};
/**
 * POST: Creates customer bank account
 * @summary customers/{customerId}/bankAccounts
 */
export var createCustomerBankAccount = function (client, customerId, globalCustomersBankAccountDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/bankAccounts"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersBankAccountDtoBody,
    }, options);
};
/**
 * PUT: Updates customer bank account
 * @summary customers/{customerId}/bankAccounts/{bankAccountId}
 */
export var updateCustomerBankAccount = function (client, customerId, bankAccountId, globalCustomersBankAccountDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/bankAccounts/").concat(bankAccountId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersBankAccountDtoBody,
    }, options);
};
/**
 * DELETE: Removes customer bank account by Id
 * @summary customers/{customerId}/bankAccounts/{bankAccountId}
 */
export var deleteCustomerBankAccount = function (client, customerId, bankAccountId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/bankAccounts/").concat(bankAccountId), method: 'delete', headers: headers }, options);
};
/**
 * GET: Gets metadata information for bank account endpoints of the customer with given customer id
 * @summary customers/{customerId}/bankAccountsMetadata
 */
export var getCustomerBankAccountsMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/bankAccountsMetadata"), method: 'get', headers: headers }, options);
};
/**
 * POST: Authorize customer's bank account
 * @summary customers/{customerId}/bankAccounts/{bankAccountId}/authorizationRequest
 */
export var createCustomerBankAccountAuthorizationRequest = function (client, customerId, bankAccountId, globalCustomersBankAccountAuthorizationRequestDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/bankAccounts/").concat(bankAccountId, "/authorizationRequest"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersBankAccountAuthorizationRequestDto,
    }, options);
};
/**
 * GET: Provides all bank branches matching the optional filters
 * @summary bankBranches
 */
export var getBankBranches = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/bankBranches", method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Provides bank branch by id
 * @summary bankBranches/{bankBranchId}
 */
export var getBankBranch = function (client, bankBranchId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/bankBranches/".concat(bankBranchId), method: 'get', headers: headers }, options);
};
/**
 * GET: Provides all banks
 * @summary banks
 */
export var getBanks = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/banks", method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Returns bank by id
 * @summary banks/{bankId}
 */
export var getBank = function (client, bankId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/banks/".concat(bankId), method: 'get', headers: headers }, options);
};
/**
 * POST: Apply shopping bag related offer
 * @summary shoppingSessions/{sessionId}/basketOffers/{offerId}
 */
export var createShoppingSessionBasketOffer = function (client, sessionId, offerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/basketOffers/").concat(offerId), method: 'post', headers: headers }, options);
};
/**
 * PUT: Purchase shopping bag related offer
 * @summary shoppingSessions/{sessionId}/basketOffers/{offerId}
 */
export var updateShoppingSessionBasketOffer = function (client, sessionId, offerId, globalShoppingOfferChoicesDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/basketOffers/").concat(offerId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingOfferChoicesDto,
    }, options);
};
/**
 * GET: Get list of shopping bag related offers
 * @summary shoppingSessions/{sessionId}/basketOffers
 */
export var getShoppingSessionBasketOffers = function (client, sessionId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/basketOffers"), method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Gets available blocking codes
 * @summary blockingCodes
 */
export var getBlockingCodes = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/blockingCodes", method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Gets blockings for given customer
 * @summary customers/{customerId}/blockings
 */
export var getCustomerBlockings = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/blockings"), method: 'get', headers: headers, params: params }, options);
};
/**
 * DELETE: Deletes single blocking for customer
 * @summary customers/{customerId}/blockings/{blockingId}
 */
export var deleteCustomerBlocking = function (client, customerId, blockingId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/blockings/").concat(blockingId), method: 'delete', headers: headers }, options);
};
/**
 * GET: Returns branch for given customer
 * @summary customers/{customerId}/branch
 */
export var getCustomerBranch = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/branch"), method: 'get', headers: headers }, options);
};
/**
 * PUT: Updates branch for given customer
 * @summary customers/{customerId}/branch
 */
export var updateCustomerBranch = function (client, customerId, globalCustomersCustomerBranchDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/branch"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersCustomerBranchDto,
    }, options);
};
/**
 * GET: Returns metadata for customer branch
 * @summary customers/{customerId}/branchMetadata
 */
export var getCustomerBranchMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/branchMetadata"), method: 'get', headers: headers }, options);
};
/**
 * GET: Returns all available Oriflame branches
 * @summary branches
 */
export var getBranches = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/branches", method: 'get', headers: headers }, options);
};
/**
 * GET: Returns specific branch by ID
 * @summary branches/{branchId}
 */
export var getBranch = function (client, branchId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/branches/".concat(branchId), method: 'get', headers: headers }, options);
};
/**
 * Get all brands, optionally filtered by given category
 * @summary brands
 */
export var getBrands = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/brands", method: 'get', headers: headers, params: params }, options);
};
/**
 * POST: Creates a record of a call interaction between customer service and the customer.
 * @summary callInteractions
 */
export var createCallInteraction = function (client, globalCallInteractionsCallInteractionDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/callInteractions",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCallInteractionsCallInteractionDto,
    }, options);
};
/**
 * GET: Gets campaigns points of the customer
 * @summary campaigns/{campaignId}/points
 */
export var getCampaignPoints = function (client, campaignId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/campaigns/".concat(campaignId, "/points"), method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Gets campaigns points of the sponsor earned by recruits
 * @summary campaigns/{campaignId}/recruitPoints
 */
export var getCampaignRecruitPoints = function (client, campaignId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/campaigns/".concat(campaignId, "/recruitPoints"), method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Gets campaigns filterable by optional parameters
 * @summary campaigns
 */
export var getCampaigns = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/campaigns", method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Get specific campaign
 * @summary campaigns/{campaignId}
 */
export var getCampaign = function (client, campaignId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/campaigns/".concat(campaignId), method: 'get', headers: headers }, options);
};
/**
 * GET: Gets configuration of welcome program step targets
 * @summary campaigns/welcomeProgram/targets
 */
export var getCampaignsWelcomeProgramTargets = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/campaigns/welcomeProgram/targets", method: 'get', headers: headers }, options);
};
/**
 * GET: Gets welcome program benefits
 * @summary campaigns/welcomeProgram/{step}/benefits
 */
export var getCampaignsWelcomeProgramBenefits = function (client, step, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/campaigns/welcomeProgram/".concat(step, "/benefits"), method: 'get', headers: headers }, options);
};
/**
 * GET: Gets configuration of activity program step targets
 * @summary campaigns/activityProgram/targets
 */
export var getCampaignsActivityProgramTargets = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/campaigns/activityProgram/targets", method: 'get', headers: headers }, options);
};
/**
 * Gets collection of points assigned to products in campaign
 * @summary customers/{customerId}/campaigns/{campaignType}/benefits
 */
export var getCustomerCampaignBenefits = function (client, customerId, campaignType, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/campaigns/").concat(campaignType, "/benefits"),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
/**
 * GET: Gets orders of the customer together with points earned and redeemed by that orders
<param name="tenant">Tenant name</param><param name="customerId">Customer Id</param><param name="periodId">Period Id</param><param name="filters">Additional filter URL encoded expression. Eg. Bp GT 100 | (ConsultantName CONTAINS John & ConsultantName NEQ Rambo)</param><param name="sort">Sort expression (field sortType)</param><param name="includeTotalCountInResult">Include total count in result</param><param name="skip">Skip</param><param name="take">Take</param>
 * @summary customer/{customerId}/reports/campaignPointsByOrders
 */
export var getCustomerReportsCampaignPointsByOrders = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customer/".concat(customerId, "/reports/campaignPointsByOrders"),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
/**
 * GET: Provide content of the catalogue
 * @summary catalogues/catalogue/{catalogueCode}/content
 */
export var getCataloguesCatalogueContent = function (client, catalogueCode, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/catalogues/catalogue/".concat(catalogueCode, "/content"), method: 'get', headers: headers, params: params }, options);
};
/**
 * Gets configuration for CatalogueIPaper for authorized customer.
 * @summary applications/catalogueIPaper/customers/{customerId}/configuration
 */
export var getApplicationsCatalogueIPaperCustomerConfiguration = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/catalogueIPaper/customers/".concat(customerId, "/configuration"),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * GET: Provide catalogue item
 * @summary catalogues/{catalogueId}/catalogueItems/{catalogueItemId}
 */
export var getCatalogueCatalogueItem = function (client, catalogueId, catalogueItemId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/catalogues/".concat(catalogueId, "/catalogueItems/").concat(catalogueItemId), method: 'get', headers: headers }, options);
};
/**
 * GET: Provide items of the catalogue
 * @summary catalogues/{catalogueId}/catalogueItems
 */
export var getCatalogueCatalogueItems = function (client, catalogueId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/catalogues/".concat(catalogueId, "/catalogueItems"), method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Provide merchandising offers related to printed catalogue
 * @summary catalogueOffers
 */
export var getCatalogueOffers = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/catalogueOffers", method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Provide catalogues related to the period
 * @deprecated
 * @summary catalogues
 */
export var getCataloguesDeprecated = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/catalogues", method: 'get', headers: headers, params: params }, options);
};
/**
 * Get social media library category by categoryId.
 * @summary socialMediaLibrary/categories/{categoryId}
 */
export var getSocialMediaLibraryCategory = function (client, categoryId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/socialMediaLibrary/categories/".concat(categoryId), method: 'get', headers: headers }, options);
};
/**
 * Get social media library category by part of the name
 * @summary socialMediaLibrary/categories
 */
export var getSocialMediaLibraryCategories = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/socialMediaLibrary/categories", method: 'get', headers: headers, params: params }, options);
};
/**
 * Get all categories
 * @summary categories
 */
export var getCategories = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/categories", method: 'get', headers: headers }, options);
};
/**
 * GET: Returns Chat bot configuration
 * @summary applications/chatBot/configuration
 */
export var getApplicationsChatBotConfiguration = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/chatBot/configuration", method: 'get', headers: headers }, options);
};
/**
 * GET: Returns catalogue items from all catalogues for specified period and product code
 * @summary applications/claimsSpa/catalogueItemsSearch
 */
export var getApplicationsClaimsSpaCatalogueItemsSearch = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/claimsSpa/catalogueItemsSearch", method: 'get', headers: headers, params: params }, options);
};
/**
 * Gets collection of concept labels for anonymous customer.
 * @summary conceptLabels
 */
export var getConceptLabels = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/conceptLabels", method: 'get', headers: headers, params: params }, options);
};
/**
 * POST: Returns concepts
 * @summary concepts
 */
export var getConcepts = function (client, globalConceptsQueryDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/concepts",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalConceptsQueryDto,
    }, options);
};
/**
 * GET: Provides concept
 * @summary concepts/{conceptCode}
 */
export var getConcept = function (client, conceptCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/concepts/".concat(conceptCode), method: 'get', headers: headers }, options);
};
/**
 * Submits email with backoffice configuration
 * @summary applications/concernReportForm
 */
export var createApplicationsConcernReportForm = function (client, globalConcernReportFormConcernReportFormDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/concernReportForm",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalConcernReportFormConcernReportFormDto,
    }, options);
};
/**
 * Get social media library configurations
 * @summary applications/socialMediaLibrary/configuration
 */
export var getApplicationsSocialMediaLibraryConfiguration = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/socialMediaLibrary/configuration", method: 'get', headers: headers }, options);
};
/**
 * POST: Confirms entity (email, phone etc.) by confirmation code
 * @summary customers/{customerId}/confirmation
 */
export var createCustomerConfirmation = function (client, customerId, globalCustomersConfirmationDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/confirmation"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersConfirmationDto,
    }, options);
};
/**
 * Provides information about connected user to WeChat account
 * @summary login/providers/weChat/externalAccount/{unionId}/connectedUser
 */
export var getLoginProvidersWeChatExternalAccountConnectedUser = function (client, unionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/login/providers/weChat/externalAccount/".concat(unionId, "/connectedUser"),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * Gets the titles.
 * @summary consultantTitles
 */
export var getConsultantTitles = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/consultantTitles", method: 'get', headers: headers }, options);
};
/**
 * GET: Returns information about contact details of registration with given ID
 * @summary customerRegistrations/{registrationId}/contactDetails
 */
export var getCustomerRegistrationContactDetails = function (client, registrationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customerRegistrations/".concat(registrationId, "/contactDetails"), method: 'get', headers: headers }, options);
};
/**
 * PUT: Modifies information about contact details of registration with given ID
 * @summary customerRegistrations/{registrationId}/contactDetails
 */
export var updateCustomerRegistrationContactDetails = function (client, registrationId, globalCustomerRegistrationsRegistrationContactDetailsDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customerRegistrations/".concat(registrationId, "/contactDetails"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomerRegistrationsRegistrationContactDetailsDto,
    }, options);
};
/**
 * POST: Confirms contact details by confirmation code
 * @summary customerRegistrations/{registrationId}/contactDetails/confirmation
 */
export var createCustomerRegistrationContactDetailsConfirmation = function (client, registrationId, globalCustomerRegistrationsRegistrationContactDetailsConfirmationDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customerRegistrations/".concat(registrationId, "/contactDetails/confirmation"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomerRegistrationsRegistrationContactDetailsConfirmationDto,
    }, options);
};
/**
 * GET: Returns documents for specific custom document
 * @summary customers/{customerId}/customDocuments/{customDocumentId}
 */
export var getCustomerCustomDocument = function (client, customerId, customDocumentId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/customDocuments/").concat(customDocumentId), method: 'get', headers: headers }, options);
};
/**
 * PUT: Change data for specific custom document (temporary document are submitted and will no longer be deleted)
 * @summary customers/{customerId}/customDocuments/{customDocumentId}
 */
export var updateCustomerCustomDocument = function (client, customerId, customDocumentId, globalCustomersCustomDocumentsDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/customDocuments/").concat(customDocumentId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersCustomDocumentsDto,
    }, options);
};
/**
 * Get customer Id by consultant number
 * @summary consultants/{consultantNumber}/customerId
 */
export var getConsultantCustomerId = function (client, consultantNumber, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/consultants/".concat(consultantNumber, "/customerId"), method: 'get', headers: headers }, options);
};
/**
 * Get consultant number for customer
 * @summary customers/{customerId}/consultantNumber
 */
export var getCustomerConsultantNumber = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/consultantNumber"), method: 'get', headers: headers }, options);
};
/**
 * Obsolete
 * @deprecated
 * @summary customer/{customerId}/consultantNumber
 */
export var getCustomerConsultantNumberDeprecated = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customer/".concat(customerId, "/consultantNumber"), method: 'get', headers: headers }, options);
};
/**
 * Obsolete
 * @deprecated
 * @summary consultant/{consultantNumber}/customerId
 */
export var getConsultantCustomerIdDeprecated = function (client, consultantNumber, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/consultant/".concat(consultantNumber, "/customerId"), method: 'get', headers: headers }, options);
};
/**
 * Gets collection of concept labels for anonymous customer.
 * @summary customers/{customerId}/conceptLabels
 */
export var getCustomerConceptLabels = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/conceptLabels"), method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Gets the information about the customer for given customer id
 * @summary customers/{customerId}/info
 */
export var getCustomerInfo = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/info"), method: 'get', headers: headers }, options);
};
/**
 * GET: Gets the metadata about customer info API
 * @summary customers/{customerId}/infoMetadata
 */
export var getCustomerInfoMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/infoMetadata"), method: 'get', headers: headers }, options);
};
/**
 * GET: Welcome program progress of the consultant
 * @summary customers/{customerId}/welcomeProgram
 */
export var getCustomerWelcomeProgram = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/welcomeProgram"), method: 'get', headers: headers }, options);
};
/**
 * GET: Activity program progress of the consultant
 * @summary customers/{customerId}/activityProgram
 */
export var getCustomerActivityProgram = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/activityProgram"), method: 'get', headers: headers }, options);
};
/**
 * GET: Recruitment campaign data
 * @summary customers/{customerId}/recruitmentCampaign
 */
export var getCustomerRecruitmentCampaign = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/recruitmentCampaign"), method: 'get', headers: headers }, options);
};
/**
 * GET: Consultant personal sales for the current period
 * @summary customers/{customerId}/personalSales
 */
export var getCustomerPersonalSales = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/personalSales"), method: 'get', headers: headers }, options);
};
/**
 * GET: Consultant personal sales for 3 past periods
 * @summary customers/{customerId}/personalSalesHistory
 */
export var getCustomerPersonalSalesHistory = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/personalSalesHistory"), method: 'get', headers: headers }, options);
};
/**
 * GET: Get current loyalty program overview
 * @summary customers/{customerId}/loyaltyProgram
 */
export var getCustomerLoyaltyProgram = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/loyaltyProgram"), method: 'get', headers: headers }, options);
};
/**
 * GET: Returns metadata for customer attributes
 * @summary customers/{customerId}/metadata
 */
export var getCustomerMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/metadata"), method: 'get', headers: headers }, options);
};
/**
 * Subscribes or returns status of newsletter subscription for given email, origin and source values.
 * @summary customers/{customerId}/newsletterSubscriptions
 */
export var createCustomerNewsletterSubscription = function (client, customerId, globalNewsletterSubscriptionsNewsletterSubscriptionsDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/newsletterSubscriptions"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalNewsletterSubscriptionsNewsletterSubscriptionsDtoBody,
    }, options);
};
/**
 * Gets collection of product labels for a specific customer.
 * @summary customers/{customerId}/productsLabels
 */
export var getCustomerProductsLabels = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/productsLabels"), method: 'get', headers: headers, params: params }, options);
};
/**
 * Returns set of customer terms which are required to be accepted
 * @summary customers/{customerId}/requiredTerms
 */
export var getCustomerRequiredTerms = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/requiredTerms"), method: 'get', headers: headers, params: params }, options);
};
/**
 * Returns customer status by given request query
 * @summary reports/customerStatuses
 */
export var createReportsCustomerStatus = function (client, globalReportsCustomerStatusesRequestDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/reports/customerStatuses",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalReportsCustomerStatusesRequestDto,
    }, options);
};
/**
 * GET: customer status
 * @summary customers/{customerId}/customerStatus
 */
export var getCustomerCustomerStatus = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/customerStatus"), method: 'get', headers: headers }, options);
};
/**
 * PUT: modify customer's status
 * @summary customers/{customerId}/customerStatus
 */
export var updateCustomerCustomerStatus = function (client, customerId, globalCustomersCustomerStatusDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/customerStatus"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersCustomerStatusDto,
    }, options);
};
/**
 * GET: Gets customer status metadata
 * @summary customers/{customerId}/customerStatusMetadata
 */
export var getCustomerCustomerStatusMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/customerStatusMetadata"), method: 'get', headers: headers }, options);
};
/**
 * Gets the title.
 * @summary customers/{customerId}/localConsultantTitle
 */
export var getCustomerLocalConsultantTitle = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/localConsultantTitle"), method: 'get', headers: headers, params: params }, options);
};
/**
 * Gets documents in folder
 * @summary digitalDocuments
 */
export var getDigitalDocuments = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/digitalDocuments", method: 'get', headers: headers, params: params }, options);
};
/**
 * Gets document by ID
 * @summary digitalDocuments/{id}
 */
export var getDigitalDocument = function (client, id, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/digitalDocuments/".concat(id), method: 'get', headers: headers }, options);
};
/**
 * Gets document content (direct download) by document ID and content ID
 * @summary digitalDocuments/{id}/contents/{contentId}
 */
export var getDigitalDocumentContent = function (client, id, contentId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/digitalDocuments/".concat(id, "/contents/").concat(contentId),
        method: 'get',
        headers: headers,
        responseType: 'blob',
    }, options);
};
/**
 * Gets document content (direct download) - latest revision
 * @summary digitalDocuments/{id}/latestContent
 */
export var getDigitalDocumentLatestContent = function (client, id, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/digitalDocuments/".concat(id, "/latestContent"), method: 'get', headers: headers, responseType: 'blob' }, options);
};
/**
 * GET: Get customer's delivery address
 * @summary customers/{customerId}/deliveryAddresses/{deliveryAddressId}
 */
export var getCustomerDeliveryAddress = function (client, customerId, deliveryAddressId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/deliveryAddresses/").concat(deliveryAddressId),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * GET: Provide delivery channel
 * @summary deliveryChannels/{deliveryChannelId}
 */
export var getDeliveryChannel = function (client, deliveryChannelId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/deliveryChannels/".concat(deliveryChannelId), method: 'get', headers: headers }, options);
};
/**
 * GET: Provide delivery channel address
 * @summary deliveryChannels/{deliveryChannelId}/address
 */
export var getDeliveryChannelAddress = function (client, deliveryChannelId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/deliveryChannels/".concat(deliveryChannelId, "/address"), method: 'get', headers: headers }, options);
};
/**
 * GET: Provide delivery channel coordinates
 * @summary deliveryChannels/{deliveryChannelId}/coordinates
 */
export var getDeliveryChannelCoordinates = function (client, deliveryChannelId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/deliveryChannels/".concat(deliveryChannelId, "/coordinates"), method: 'get', headers: headers }, options);
};
/**
 * GET: Find available delivery channel based on search criteria
 * @summary shoppingSessions/{sessionId}/deliveryChannels
 */
export var getShoppingSessionDeliveryChannels = function (client, sessionId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/deliveryChannels"), method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Find available pick-up points based on search criteria on the map
 * @summary shoppingSessions/{sessionId}/clusteredPickupPoints
 */
export var getShoppingSessionClusteredPickupPoints = function (client, sessionId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/clusteredPickupPoints"), method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Gets delivery channel by id
 * @summary shoppingSessions/{sessionId}/deliveryChannels/{deliveryChannelId}
 */
export var getShoppingSessionDeliveryChannel = function (client, sessionId, deliveryChannelId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/deliveryChannels/").concat(deliveryChannelId),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * GET: Provides available delivery methods
 * @summary shoppingSessions/{sessionId}/deliveryMethods
 */
export var getShoppingSessionDeliveryMethods = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/deliveryMethods"), method: 'get', headers: headers }, options);
};
/**
 * GET: Provide relevant delivery filters
 * @summary shoppingSessions/{sessionId}/deliveryFilters
 */
export var getShoppingSessionDeliveryFilters = function (client, sessionId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/deliveryFilters"), method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Find available delivery options
 * @summary shoppingSessions/{sessionId}/deliveryOptions
 */
export var getShoppingSessionDeliveryOptions = function (client, sessionId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/deliveryOptions"), method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Provide selected delivery channel and address
 * @summary shoppingSessions/{sessionId}/delivery
 */
export var getShoppingSessionDelivery = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/delivery"), method: 'get', headers: headers }, options);
};
/**
 * PUT: Update selected delivery channel and address
 * @summary shoppingSessions/{sessionId}/delivery
 */
export var updateShoppingSessionDelivery = function (client, sessionId, globalShoppingDeliveryDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/delivery"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingDeliveryDto,
    }, options);
};
/**
 * Courier can post information about new status of a delivery
 * @summary couriers/{courierId}/wayBillNumbers/{wayBillNumber}/deliveryStatuses
 */
export var createCourierWayBillNumberDeliveryStatus = function (client, courierId, wayBillNumber, globalDeliveryDeliveryStatusDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/couriers/".concat(courierId, "/wayBillNumbers/").concat(wayBillNumber, "/deliveryStatuses"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalDeliveryDeliveryStatusDto,
    }, options);
};
/**
 * Saves customer document.
 * @summary customers/{customerId}/documents
 */
export var createCustomerDocument = function (client, customerId, createCustomerDocumentBody, params, headers, options) {
    var customInstance = client.createFetcher();
    var formData = new FormData();
    if (createCustomerDocumentBody.file !== undefined) {
        formData.append('file', createCustomerDocumentBody.file);
    }
    return customInstance({
        url: "/customers/".concat(customerId, "/documents"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'multipart/form-data' }, headers),
        data: formData,
        params: params,
    }, options);
};
/**
 * Gets customer image by id and optionally resizes it,
if width and height parameters are provided.
Caches result for 7 days.
 * @summary customers/{customerId}/documents/{documentId}/image
 */
export var getCustomerDocumentImage = function (client, customerId, documentId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/documents/").concat(documentId, "/image"),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
/**
 * Gets customer binary document by id.
Caches result for 7 days.
 * @summary customers/{customerId}/documents/{documentId}
 */
export var getCustomerDocument = function (client, customerId, documentId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/documents/").concat(documentId), method: 'get', headers: headers }, options);
};
/**
 * Delete customers document
 * @summary customers/{customerId}/documents/{documentId}
 */
export var deleteCustomerDocument = function (client, customerId, documentId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/documents/").concat(documentId), method: 'delete', headers: headers }, options);
};
/**
 * Gets the customer documents ids.
 * @summary customers/{customerId}/documents/infos
 */
export var getCustomerDocumentsInfos = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/documents/infos"), method: 'get', headers: headers, params: params }, options);
};
/**
 * Gets all available document types
 * @summary documentTypes
 */
export var getDocumentTypes = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/documentTypes", method: 'get', headers: headers }, options);
};
/**
 * Saves an anonymous (without assigning customer)
 * @summary documents
 */
export var createDocument = function (client, createCustomerDocumentBody, params, headers, options) {
    var customInstance = client.createFetcher();
    var formData = new FormData();
    if (createCustomerDocumentBody.file !== undefined) {
        formData.append('file', createCustomerDocumentBody.file);
    }
    return customInstance({
        url: "/documents",
        method: 'post',
        headers: __assign({ 'Content-Type': 'multipart/form-data' }, headers),
        data: formData,
        params: params,
    }, options);
};
/**
 * Gets anonymous (without assigned customer) image by id and optionally resizes it,
if width and height parameters are provided.
Caches result for 7 days.
 * @summary documents/{documentId}/image
 */
export var getDocumentImage = function (client, documentId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/documents/".concat(documentId, "/image"), method: 'get', headers: headers, params: params }, options);
};
/**
 * Gets anonymous (without assigned customer) binary document by id.
Caches result for 7 days.
 * @summary documents/{documentId}
 */
export var getDocument = function (client, documentId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/documents/".concat(documentId), method: 'get', headers: headers }, options);
};
/**
 * Gets the anonymous (without assigned customer) documents info.
 * @summary documents/infos
 */
export var getDocumentsInfos = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/documents/infos", method: 'get', headers: headers, params: params }, options);
};
/**
 * Get document approvals by filter parameters
 * @summary customers/{customerId}/documentApprovals
 */
export var getCustomerDocumentApprovals = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/documentApprovals"), method: 'get', headers: headers, params: params }, options);
};
/**
 * Create document approval
 * @summary customers/{customerId}/documentApprovals
 */
export var createCustomerDocumentApproval = function (client, customerId, globalCustomersDocumentApprovalDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/documentApprovals"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersDocumentApprovalDto,
    }, options);
};
/**
 * Get document approval by ID
 * @summary customers/{customerId}/documentApprovals/{documentApprovalId}
 */
export var getCustomerDocumentApproval = function (client, customerId, documentApprovalId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/documentApprovals/").concat(documentApprovalId),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * GET: Returns downline customers for given customer
 * @summary customers/{customerId}/downlineCustomers
 */
export var getCustomerDownlineCustomers = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/downlineCustomers"), method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Get downline performance kpis
 * @summary customers/{customerId}/downlinePerformance
 */
export var getCustomerDownlinePerformance = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/downlinePerformance"), method: 'get', headers: headers, params: params }, options);
};
/**
 * Get summary data about consultants in downline
 * @summary customers/{customerId}/downlineSummary
 */
export var getCustomerDownlineSummary = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/downlineSummary"), method: 'get', headers: headers, params: params }, options);
};
/**
 * GET - provides collection of editorial articles
 * @summary editorialArticles
 */
export var getEditorialArticles = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/editorialArticles", method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Localization for EInvoice application
 * @summary applications/eInvoice/localization
 */
export var getApplicationsEInvoiceLocalization = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/eInvoice/localization", method: 'get', headers: headers }, options);
};
/**
 * GET: Returns documents for identity card
 * @summary customers/{customerId}/eInvoiceApproval
 */
export var getCustomerEInvoiceApproval = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/eInvoiceApproval"), method: 'get', headers: headers }, options);
};
/**
 * PUT: Change e-invoice approval flag
 * @summary customers/{customerId}/eInvoiceApproval
 */
export var updateCustomerEInvoiceApproval = function (client, customerId, globalCustomersCustomerBooleanDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/eInvoiceApproval"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersCustomerBooleanDtoBody,
    }, options);
};
/**
 * Gets customer emails.
Customer can own only single active and single pending email at the moment.
 * @summary customers/{customerId}/emails
 */
export var getCustomerEmails = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/emails"), method: 'get', headers: headers }, options);
};
/**
 * Sets new/overrides email for customer.
Customer can own only single active and single pending email at the moment.
Email is stored as pending and waiting for confirmation
 * @summary customers/{customerId}/emails
 */
export var createCustomerEmail = function (client, customerId, globalCustomersEmailDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/emails"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersEmailDto,
    }, options);
};
/**
 * Delete customers active or pending email.
 * @summary customers/{customerId}/emails/{emailAddress}
 */
export var deleteCustomerEmail = function (client, customerId, emailAddress, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/emails/").concat(emailAddress), method: 'delete', headers: headers }, options);
};
/**
 * GET: Gets metadata information for email endpoints of the customer with given customer id
 * @summary customers/{customerId}/emailsMetadata
 */
export var getCustomerEmailsMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/emailsMetadata"), method: 'get', headers: headers }, options);
};
/**
 * GET: Gets the status of verification process for given email and customer id
 * @summary customers/{customerId}/emails/{emailAddress}/verificationRequest
 */
export var getCustomerEmailVerificationRequest = function (client, customerId, emailAddress, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/emails/").concat(emailAddress, "/verificationRequest"),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * PUT: Requests resending verification email for customer with given customer id and email address
 * @summary customers/{customerId}/emails/{emailAddress}/verificationRequest
 */
export var updateCustomerEmailVerificationRequest = function (client, customerId, emailAddress, globalCustomersEmailVerificationRequestDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/emails/").concat(emailAddress, "/verificationRequest"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersEmailVerificationRequestDto,
    }, options);
};
/**
 * Get end consumer order by ItemCode
 * @summary endConsumerOrders/{endConsumerOrderId}/items/{itemCode}
 */
export var getEndConsumerOrderItem = function (client, endConsumerOrderId, itemCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/endConsumerOrders/".concat(endConsumerOrderId, "/items/").concat(itemCode), method: 'get', headers: headers }, options);
};
/**
 * Update existing item on end consumer order
 * @summary endConsumerOrders/{endConsumerOrderId}/items/{itemCode}
 */
export var updateEndConsumerOrderItem = function (client, endConsumerOrderId, itemCode, globalEndConsumerOrdersEndConsumerOrderItemDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/endConsumerOrders/".concat(endConsumerOrderId, "/items/").concat(itemCode),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalEndConsumerOrdersEndConsumerOrderItemDto,
    }, options);
};
/**
 * Delete/remove item from end consumer order
 * @summary endConsumerOrders/{endConsumerOrderId}/items/{itemCode}
 */
export var deleteEndConsumerOrderItem = function (client, endConsumerOrderId, itemCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/endConsumerOrders/".concat(endConsumerOrderId, "/items/").concat(itemCode),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * Add new item to end consumer order
 * @summary endConsumerOrders/{endConsumerOrderId}/items
 */
export var createEndConsumerOrderItem = function (client, endConsumerOrderId, globalEndConsumerOrdersEndConsumerOrderItemDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/endConsumerOrders/".concat(endConsumerOrderId, "/items"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalEndConsumerOrdersEndConsumerOrderItemDto,
    }, options);
};
/**
 * Creates new end consumer order
 * @summary endConsumerOrders
 */
export var createEndConsumerOrder = function (client, globalEndConsumerOrdersEndConsumerOrderDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/endConsumerOrders",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalEndConsumerOrdersEndConsumerOrderDto,
    }, options);
};
/**
 * Get all end consumer orders for given customer ID
 * @summary endConsumerOrders
 */
export var getEndConsumerOrders = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/endConsumerOrders", method: 'get', headers: headers, params: params }, options);
};
/**
 * Get end consumer order by id
 * @summary endConsumerOrders/{endConsumerOrderId}
 */
export var getEndConsumerOrder = function (client, endConsumerOrderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/endConsumerOrders/".concat(endConsumerOrderId), method: 'get', headers: headers }, options);
};
/**
 * Create approval for end consumer order
 * @summary endConsumerOrders/{endConsumerOrderId}/approval
 */
export var createEndConsumerOrderApproval = function (client, endConsumerOrderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/endConsumerOrders/".concat(endConsumerOrderId, "/approval"), method: 'post', headers: headers }, options);
};
/**
 * Delete approval for end consumer order
 * @summary endConsumerOrders/{endConsumerOrderId}/approval
 */
export var deleteEndConsumerOrderApproval = function (client, endConsumerOrderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/endConsumerOrders/".concat(endConsumerOrderId, "/approval"), method: 'delete', headers: headers }, options);
};
/**
 * GET: Gets the collection of all end consumers of the customer with given customer id
 * @summary customers/{customerId}/endConsumers
 */
export var getCustomerEndConsumers = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/endConsumers"), method: 'get', headers: headers }, options);
};
/**
 * POST: Creates new end consumer for the customer with given customer id
 * @summary customers/{customerId}/endConsumers
 */
export var createCustomerEndConsumer = function (client, customerId, globalCustomersEndConsumerDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/endConsumers"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersEndConsumerDtoBody,
    }, options);
};
/**
 * GET: Get specific end consumer of the customer with given customer id
 * @summary customers/{customerId}/endConsumers/{endConsumerId}
 */
export var getCustomerEndConsumer = function (client, customerId, endConsumerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/endConsumers/").concat(endConsumerId), method: 'get', headers: headers }, options);
};
/**
 * PUT: Updates end consumer for the customer with given customer id
 * @summary customers/{customerId}/endConsumers/{endConsumerId}
 */
export var updateCustomerEndConsumer = function (client, customerId, endConsumerId, globalCustomersEndConsumerDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/endConsumers/").concat(endConsumerId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersEndConsumerDtoBody,
    }, options);
};
/**
 * DELETE: Removes end consumer for the customer with given customer id
 * @summary customers/{customerId}/endConsumers/{endConsumerId}
 */
export var deleteCustomerEndConsumer = function (client, customerId, endConsumerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/endConsumers/").concat(endConsumerId), method: 'delete', headers: headers }, options);
};
/**
 * GET: Returns metadata information for endConsumer endpoints
 * @summary endConsumersMetadata
 */
export var getEndConsumersMetadata = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/endConsumersMetadata", method: 'get', headers: headers }, options);
};
/**
 * GET: Localization for EndCustomer Referral Discount application
 * @summary applications/endCustomerReferralDiscount/localization
 */
export var getApplicationsEndCustomerReferralDiscountLocalization = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/endCustomerReferralDiscount/localization", method: 'get', headers: headers }, options);
};
/**
 * POST: Creates new end customer
 * @summary endCustomers
 */
export var createEndCustomer = function (client, globalCustomersEndCustomerDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/endCustomers",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersEndCustomerDto,
    }, options);
};
/**
 * GET: Gets metadata information for endCustomers endpoints
 * @summary endCustomersMetadata
 */
export var getEndCustomersMetadata = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/endCustomersMetadata", method: 'get', headers: headers }, options);
};
/**
 * Gets identity server endpoints for communication with identity server (API, OAuth, OpenId)
 * @deprecated
 * @summary system/endpoints/identityServer
 */
export var getSystemEndpointsIdentityServerDeprecated = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/system/endpoints/identityServer", method: 'get', headers: headers }, options);
};
/**
 * Gets Online url for specific tenant. It could be used for redirects to oriflame pages
 * @deprecated
 * @summary system/endpoints/online
 */
export var getSystemEndpointsOnlineDeprecated = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/system/endpoints/online", method: 'get', headers: headers }, options);
};
/**
 * GET: Gets customer eWallet accounts
 * @summary customers/{customerId}/eWalletAccounts
 */
export var getCustomerEWalletAccounts = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/eWalletAccounts"), method: 'get', headers: headers }, options);
};
/**
 * POST: Creates customer eWallet account
 * @summary customers/{customerId}/eWalletAccounts
 */
export var createCustomerEWalletAccount = function (client, customerId, globalCustomersEWalletAccountDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/eWalletAccounts"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersEWalletAccountDtoBody,
    }, options);
};
/**
 * PUT: Updates customer eWallet account
 * @summary customers/{customerId}/eWalletAccounts/{eWalletAccountId}
 */
export var updateCustomerEWalletAccount = function (client, customerId, eWalletAccountId, globalCustomersEWalletAccountDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/eWalletAccounts/").concat(eWalletAccountId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersEWalletAccountDtoBody,
    }, options);
};
/**
 * DELETE: Removes customer eWallet account by ID
 * @summary customers/{customerId}/eWalletAccounts/{eWalletAccountId}
 */
export var deleteCustomerEWalletAccount = function (client, customerId, eWalletAccountId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/eWalletAccounts/").concat(eWalletAccountId),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * GET: Gets metadata information for eWallet endpoints of the customer with given customer id
 * @summary customers/{customerId}/eWalletAccountsMetadata
 */
export var getCustomerEWalletAccountsMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/eWalletAccountsMetadata"), method: 'get', headers: headers }, options);
};
/**
 * Get WeChat unionId for customer id
 * @summary customers/{customerId}/externalAccounts/weChat/unionId
 */
export var getCustomerExternalAccountsWeChatUnionId = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/externalAccounts/weChat/unionId"), method: 'get', headers: headers }, options);
};
/**
 * Retrieves the profiles for external providers (FB, WeChat, VKontakte...)
 * @summary customers/{customerId}/externalProfiles
 */
export var getCustomerExternalProfiles = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/externalProfiles"), method: 'get', headers: headers }, options);
};
/**
 * Disconnects external account (FB, WeChat, VKontakte...)
 * @summary customers/{customerId}/externalAccounts/{externalProvider}
 */
export var deleteCustomerExternalAccount = function (client, customerId, externalProvider, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/externalAccounts/").concat(externalProvider),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * Gets feature toggle value for current tenant by the feature GUID.
 * @summary featureToggles/{featureId}
 */
export var getFeatureToggle = function (client, featureId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/featureToggles/".concat(featureId), method: 'get', headers: headers }, options);
};
/**
 * Gets all feature toggle values for current tenant.
 * @summary featureToggles
 */
export var getFeatureToggles = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/featureToggles", method: 'get', headers: headers }, options);
};
/**
 * Get customer's FinancialSet
 * @summary customers/{customerId}/financialSet
 */
export var getCustomerFinancialSet = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/financialSet"), method: 'get', headers: headers }, options);
};
/**
 * Gets collection of formatted price data for products
 * @summary productsFormattedPrices
 */
export var getProductsFormattedPrices = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/productsFormattedPrices", method: 'get', headers: headers, params: params }, options);
};
/**
 * Gets collection of formatted price data for concepts
 * @summary conceptsFormattedPrices
 */
export var getConceptsFormattedPrices = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/conceptsFormattedPrices", method: 'get', headers: headers, params: params }, options);
};
/**
 * Get Front Page Banners
 * @summary applications/oriflameApp/frontPageBanners
 */
export var getApplicationsOriflameAppFrontPageBanners = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/oriflameApp/frontPageBanners", method: 'get', headers: headers, params: params }, options);
};
/**
 * Get Front Page Banner by ID
 * @summary applications/oriflameApp/frontPageBanners/{frontPageBannerId}
 */
export var getApplicationsOriflameAppFrontPageBanner = function (client, frontPageBannerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/oriflameApp/frontPageBanners/".concat(frontPageBannerId),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
/**
 * GET - provides content for the Benefit Banner for segmented customer.
 * @summary applications/frontpage/customers/{customerId}/benefitBanner
 */
export var getApplicationsFrontpageCustomerBenefitBanner = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/frontpage/customers/".concat(customerId, "/benefitBanner"),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * GET: Returns Genesys widget configuration
 * @summary applications/genesysWidget
 */
export var getApplicationsGenesysWidget = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/genesysWidget", method: 'get', headers: headers }, options);
};
/**
 * GET: granted credit
 * @summary customers/{customerId}/grantedCredit
 */
export var getCustomerGrantedCredit = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/grantedCredit"), method: 'get', headers: headers }, options);
};
/**
 * PUT: granted credit limit
 * @summary customers/{customerId}/grantedCredit
 */
export var updateCustomerGrantedCredit = function (client, customerId, globalCustomersGrantedCreditDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/grantedCredit"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersGrantedCreditDto,
    }, options);
};
/**
 * GET: guarantee Credit
 * @summary customers/{customerId}/guaranteeCredit
 */
export var getCustomerGuaranteeCredit = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/guaranteeCredit"), method: 'get', headers: headers }, options);
};
/**
 * GET: Localization for guarantee credit application
 * @summary applications/guaranteeCredit/localization
 */
export var getApplicationsGuaranteeCreditLocalization = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/guaranteeCredit/localization", method: 'get', headers: headers }, options);
};
/**
 * GET: Configuration for guarantee credit application
 * @summary applications/guaranteeCredit/grantedCreditConfiguration
 */
export var getApplicationsGuaranteeCreditGrantedCreditConfiguration = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/guaranteeCredit/grantedCreditConfiguration", method: 'get', headers: headers }, options);
};
/**
 * GET: guarantee credit customers
 * @summary applications/guaranteeCredit/customers
 */
export var getApplicationsGuaranteeCreditCustomers = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/guaranteeCredit/customers", method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Provides home delivery addresses of the customer and related delivery channels (couriers)
 * @summary shoppingSessions/{sessionId}/homeDeliveryOptions
 */
export var getShoppingSessionHomeDeliveryOptions = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/homeDeliveryOptions"), method: 'get', headers: headers }, options);
};
/**
 * GET: Returns documents for identity card
 * @summary customers/{customerId}/identityCard
 */
export var getCustomerIdentityCard = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/identityCard"), method: 'get', headers: headers }, options);
};
/**
 * PUT: Change documents for identity card (temporary document are submitted and will no longer be deleted)
 * @summary customers/{customerId}/identityCard
 */
export var updateCustomerIdentityCard = function (client, customerId, globalCustomersIdentityCardDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/identityCard"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersIdentityCardDto,
    }, options);
};
/**
 * Get social media library image info by imageInfoId
 * @summary socialMediaLibrary/imageInfos/{imageInfoId}
 */
export var getSocialMediaLibraryImageInfo = function (client, imageInfoId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/socialMediaLibrary/imageInfos/".concat(imageInfoId), method: 'get', headers: headers }, options);
};
/**
 * Get social media library images
 * @summary socialMediaLibrary/imageInfos
 */
export var getSocialMediaLibraryImageInfos = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/socialMediaLibrary/imageInfos", method: 'get', headers: headers, params: params }, options);
};
/**
 * Returns anonymous (unregistered) customer notifications.
 * @summary inAppNotifications
 */
export var getInAppNotifications = function (client, headers, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/inAppNotifications", method: 'get', headers: headers, params: params }, options);
};
/**
 * Returns anonymous (unregistered) customer notifications. This method should be used to get most recent updates including new notifications.
 * @summary inAppNotificationUpdates
 */
export var getInAppNotificationUpdates = function (client, headers, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/inAppNotificationUpdates", method: 'get', headers: headers, params: params }, options);
};
/**
 * Returns client notifications.
 * @summary customers/{customerId}/inAppNotifications
 */
export var getCustomerInAppNotifications = function (client, customerId, headers, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/inAppNotifications"), method: 'get', headers: headers, params: params }, options);
};
/**
 * Deletes all notifications of customer prior to due/current date.
 * @summary customers/{customerId}/inAppNotifications
 */
export var deleteCustomerInAppNotifications = function (client, customerId, headers, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/inAppNotifications"), method: 'delete', headers: headers, params: params }, options);
};
/**
 * Returns client notifications. This method should be used to get most recent updates including new notifications.
 * @summary customers/{customerId}/inAppNotificationUpdates
 */
export var getCustomerInAppNotificationUpdates = function (client, customerId, headers, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/inAppNotificationUpdates"), method: 'get', headers: headers, params: params }, options);
};
/**
 * Marks given notification as viewed.
 * @summary customers/{customerId}/inAppNotifications/{notificationId}/viewed
 */
export var createCustomerInAppNotificationViewed = function (client, customerId, notificationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/inAppNotifications/").concat(notificationId, "/viewed"),
        method: 'post',
        headers: headers,
    }, options);
};
/**
 * Marks all notifications of customer prior to due/current date as viewed.
 * @summary customers/{customerId}/inAppNotifications/viewed
 */
export var createCustomerInAppNotificationsViewed = function (client, customerId, headers, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/inAppNotifications/viewed"), method: 'post', headers: headers, params: params }, options);
};
/**
 * Deletes given notification.
 * @summary customers/{customerId}/inAppNotifications/{notificationId}
 */
export var deleteCustomerInAppNotification = function (client, customerId, notificationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/inAppNotifications/").concat(notificationId),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * Undo delete given notification.
 * @summary customers/{customerId}/inAppNotifications/{notificationId}/undelete
 */
export var createCustomerInAppNotificationUndelete = function (client, customerId, notificationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/inAppNotifications/").concat(notificationId, "/undelete"),
        method: 'post',
        headers: headers,
    }, options);
};
/**
 * Returns message types collection.
 * @summary notificationMessageTypes
 */
export var getNotificationMessageTypes = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/notificationMessageTypes", method: 'get', headers: headers }, options);
};
/**
 * Marks all notifications of customer prior to due/current date as seen.
 * @summary customers/{customerId}/inAppNotifications/seen
 */
export var createCustomerInAppNotificationsSeen = function (client, customerId, headers, params, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/inAppNotifications/seen"), method: 'post', headers: headers, params: params }, options);
};
/**
 * Marks given notification as seen.
 * @summary customers/{customerId}/inAppNotifications/{notificationId}/seen
 */
export var createCustomerInAppNotificationSeen = function (client, customerId, notificationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/inAppNotifications/").concat(notificationId, "/seen"),
        method: 'post',
        headers: headers,
    }, options);
};
/**
 * Returns count of unseen notifications
 * @summary customers/{customerId}/unseenNotificationsCount
 */
export var getCustomerUnseenNotificationsCount = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/unseenNotificationsCount"), method: 'get', headers: headers }, options);
};
/**
 * Gets collection of Ingredients for given ingredient Names. If collection of ingredients is empty
all ingredients are returned
 * @summary ingredients
 */
export var getIngredients = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/ingredients", method: 'get', headers: headers, params: params }, options);
};
/**
 * Gets Ingredient for given name
 * @summary ingredients/{ingredientName}
 */
export var getIngredient = function (client, ingredientName, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/ingredients/".concat(ingredientName), method: 'get', headers: headers }, options);
};
/**
 * GET: international info
 * @summary customers/{customerId}/internationalInfo
 */
export var getCustomerInternationalInfo = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/internationalInfo"), method: 'get', headers: headers }, options);
};
/**
 * Gets Invite Friend profile for the customer with given customer id
 * @summary customers/{customerId}/inviteFriendProfile
 */
export var getCustomerInviteFriendProfile = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/inviteFriendProfile"), method: 'get', headers: headers }, options);
};
/**
 * GET: Returns joining fee info and html content
 * @deprecated
 * @summary joiningFeeDialog/html
 */
export var getJoiningFeeDialogHtmlDeprecated = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/joiningFeeDialog/html", method: 'get', headers: headers }, options);
};
/**
 * GET: Returns legal information of registration with given ID
 * @summary customerRegistrations/{registrationId}/legalDetails
 */
export var getCustomerRegistrationLegalDetails = function (client, registrationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customerRegistrations/".concat(registrationId, "/legalDetails"), method: 'get', headers: headers }, options);
};
/**
 * PUT: Modifies legal information of registration with given ID
 * @summary customerRegistrations/{registrationId}/legalDetails
 */
export var updateCustomerRegistrationLegalDetails = function (client, registrationId, globalCustomerRegistrationsRegistrationLegalDetailsDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customerRegistrations/".concat(registrationId, "/legalDetails"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomerRegistrationsRegistrationLegalDetailsDto,
    }, options);
};
/**
 * GET: Returns legal document with given area manager filled in
 * @summary customers/{customerId}/legalDocument
 */
export var getCustomerLegalDocument = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/legalDocument"), method: 'get', headers: headers, params: params }, options);
};
/**
 * Get social media library localization
 * @summary applications/socialMediaLibrary/localization
 */
export var getApplicationsSocialMediaLibraryLocalization = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/socialMediaLibrary/localization", method: 'get', headers: headers }, options);
};
/**
 * GET: Returns information about Online login status - disabled?
 * @summary login/status
 */
export var getLoginStatus = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/login/status", method: 'get', headers: headers }, options);
};
/**
 * GET: Lookup for addresses by ID
 * @deprecated
 * @summary addressNodes/{nodeId}
 */
export var getAddressNodeDeprecated = function (client, nodeId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/addressNodes/".concat(nodeId), method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Returns single search result item by ID. Use 'GET addressSuggestions' to find results.
 * @summary addressSearchResults/{addressSearchResultId}
 */
export var getAddressSearchResult = function (client, addressSearchResultId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/addressSearchResults/".concat(addressSearchResultId), method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Lookup for address suggestions by filter
 * @summary addressSuggestions
 */
export var getAddressSuggestions = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/addressSuggestions", method: 'get', headers: headers, params: params }, options);
};
/**
 * Gets the looks.
 * @summary applications/makeupwizard/looks
 */
export var getApplicationsMakeupwizardLooks = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/makeupwizard/looks", method: 'get', headers: headers }, options);
};
/**
 * Gets the look tags.
 * @summary applications/makeupwizard/looktags
 */
export var getApplicationsMakeupwizardLooktags = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/makeupwizard/looktags", method: 'get', headers: headers }, options);
};
/**
 * Gets the localization.
 * @summary applications/makeupwizard/localization
 */
export var getApplicationsMakeupwizardLocalization = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/makeupwizard/localization", method: 'get', headers: headers }, options);
};
/**
 * Gets the Makeup Wizard Categories
 * @summary applications/makeupwizard/categories
 */
export var getApplicationsMakeupwizardCategories = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/makeupwizard/categories", method: 'get', headers: headers }, options);
};
/**
 * Gets the welcome screen steps.
 * @summary applications/makeupwizard/welcomeScreenSteps
 */
export var getApplicationsMakeupwizardWelcomeScreenSteps = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/makeupwizard/welcomeScreenSteps", method: 'get', headers: headers }, options);
};
/**
 * GET: Returns selected value for marital status
 * @summary customers/{customerId}/maritalStatus
 */
export var getCustomerMaritalStatus = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/maritalStatus"), method: 'get', headers: headers }, options);
};
/**
 * PUT: Change selected value for marital status
 * @summary customers/{customerId}/maritalStatus
 */
export var updateCustomerMaritalStatus = function (client, customerId, globalCustomersCustomerSelectionDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/maritalStatus"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersCustomerSelectionDtoBody,
    }, options);
};
/**
 * Get title qualification parameters
 * @summary commissionPlans/matureMarket/titleQualifications
 */
export var getCommissionPlansMatureMarketTitleQualifications = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/commissionPlans/matureMarket/titleQualifications", method: 'get', headers: headers }, options);
};
/**
 * Get personal menu data
 * @summary customers/{customerId}/menu
 */
export var getCustomerMenu = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/menu"), method: 'get', headers: headers, params: params }, options);
};
/**
 * Gets links for all existing mobile applications.
 * @summary mobileAppsLinks
 */
export var getMobileAppsLinks = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/mobileAppsLinks", method: 'get', headers: headers }, options);
};
/**
 * Returns configuration of MV7.
 * @summary applications/mv7/configuration
 */
export var getApplicationsMv7Configuration = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/mv7/configuration", method: 'get', headers: headers }, options);
};
/**
 * GET - Returns collection of Custom Links from My Page
 * @summary applications/oriflameapp/myPage
 */
export var getApplicationsOriflameappMyPage = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/oriflameapp/myPage", method: 'get', headers: headers }, options);
};
/**
 * Provides name bank contacts of specific customer
 * @summary customers/{customerId}/nameBankContacts
 */
export var getCustomerNameBankContacts = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/nameBankContacts"), method: 'get', headers: headers, params: params }, options);
};
/**
 * Adds contact for specific customer
 * @summary customers/{customerId}/nameBankContacts
 */
export var createCustomerNameBankContact = function (client, customerId, globalMobileOfficeNameBankNameBankContactDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/nameBankContacts"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalMobileOfficeNameBankNameBankContactDto,
    }, options);
};
/**
 * Gets specific name bank contact of specific customer by id
 * @summary customers/{customerId}/nameBankContacts/{contactId}
 */
export var getCustomerNameBankContact = function (client, customerId, contactId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/nameBankContacts/").concat(contactId), method: 'get', headers: headers }, options);
};
/**
 * Updates contact of specific customer
 * @summary customers/{customerId}/nameBankContacts/{contactId}
 */
export var updateCustomerNameBankContact = function (client, customerId, contactId, globalMobileOfficeNameBankNameBankContactDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/nameBankContacts/").concat(contactId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalMobileOfficeNameBankNameBankContactDto,
    }, options);
};
/**
 * Deletes contact of specific customer
 * @summary customers/{customerId}/nameBankContacts/{contactId}
 */
export var deleteCustomerNameBankContact = function (client, customerId, contactId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/nameBankContacts/").concat(contactId), method: 'delete', headers: headers }, options);
};
/**
 * Get navigation items for specific type
 * @summary applications/navigation/navigations/{navigationType}
 */
export var getApplicationsNavigationNavigation = function (client, navigationType, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/navigation/navigations/".concat(navigationType),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
/**
 * Sends search signal - it is created on specific action.
 * @summary applications/navigation/signal
 */
export var createApplicationsNavigationSignal = function (client, globalProductQuerySignalsDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/navigation/signal",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalProductQuerySignalsDto,
    }, options);
};
/**
 * Sends search signals bulk - it is created on specific action.
 * @summary applications/navigation/signalsBulk
 */
export var createApplicationsNavigationSignalsBulk = function (client, globalProductQuerySignalsBulkDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/navigation/signalsBulk",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalProductQuerySignalsBulkDto,
    }, options);
};
/**
 * Get navigation items of specific type for customer
 * @summary applications/navigation/customers/{customerId}/navigations/{navigationType}
 */
export var getApplicationsNavigationCustomerNavigation = function (client, customerId, navigationType, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/navigation/customers/".concat(customerId, "/navigations/").concat(navigationType),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
/**
 * GET: Gets the information about the customer for given customer id
 * @summary applications/navigation/customers/{customerId}/info
 */
export var getApplicationsNavigationCustomerInfo = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/navigation/customers/".concat(customerId, "/info"), method: 'get', headers: headers }, options);
};
/**
 * Provides top news for specific customer
 * @summary customers/{customerId}/news/top
 */
export var createCustomerNewsTop = function (client, customerId, globalSharedPagingDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/news/top"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalSharedPagingDto,
    }, options);
};
/**
 * Subscribes or returns status of newsletter subscription for given email, origin and source values.
 * @summary newsletterSubscriptions
 */
export var createNewsletterSubscription = function (client, globalNewsletterSubscriptionsNewsletterSubscriptionsDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/newsletterSubscriptions",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalNewsletterSubscriptionsNewsletterSubscriptionsDtoBody,
    }, options);
};
/**
 * GET: Returns nominee (e.g. spouse name)
 * @summary customers/{customerId}/nominee
 */
export var getCustomerNominee = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/nominee"), method: 'get', headers: headers }, options);
};
/**
 * PUT: Change nominee (e.g. spouse name)
 * @summary customers/{customerId}/nominee
 */
export var updateCustomerNominee = function (client, customerId, globalCustomersNomineeDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/nominee"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersNomineeDto,
    }, options);
};
/**
 * Relays mobile (inapp+push) notification delivery.
 * @summary relayNotifications/mobile
 */
export var createRelayNotificationsMobile = function (client, globalNotificationsMobileNotificationDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/relayNotifications/mobile",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalNotificationsMobileNotificationDto,
    }, options);
};
/**
 * Relays mobile (inapp+push) notification delivery. This is new version of api which allows send one notification with many recipients in one call.
 * @summary relayNotifications/mobileBulk
 */
export var createRelayNotificationsMobileBulk = function (client, globalNotificationsBulkMobileNotificationDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/relayNotifications/mobileBulk",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalNotificationsBulkMobileNotificationDto,
    }, options);
};
/**
 * Update or create new customer notification.
 * @summary customers/{customerId}/notifications
 */
export var createCustomerNotification = function (client, customerId, globalNotificationsCustomerNotificationDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/notifications"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalNotificationsCustomerNotificationDto,
    }, options);
};
/**
 * Delete customer notification.
 * @summary customers/{customerId}/notifications/{notificationId}
 */
export var deleteCustomerNotification = function (client, customerId, notificationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/notifications/").concat(notificationId), method: 'delete', headers: headers }, options);
};
/**
 * Returns single customer notification.
 * @summary customers/{customerId}/notifications/{notificationId}
 */
export var getCustomerNotification = function (client, customerId, notificationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/notifications/").concat(notificationId), method: 'get', headers: headers }, options);
};
/**
 * Send customer notification.
 * @summary customers/{customerId}/notifications/{notificationId}/send
 */
export var createCustomerNotificationSend = function (client, customerId, notificationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/notifications/").concat(notificationId, "/send"),
        method: 'post',
        headers: headers,
    }, options);
};
/**
 * Recall customer notification.
 * @summary customers/{customerId}/notifications/{notificationId}/recall
 */
export var createCustomerNotificationRecall = function (client, customerId, notificationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/notifications/").concat(notificationId, "/recall"),
        method: 'post',
        headers: headers,
    }, options);
};
/**
 * Search for customer's notifications by criteria.
 * @summary customers/{customerId}/notifications/search
 */
export var createCustomerNotificationsSearch = function (client, customerId, globalNotificationsCustomerNotificationSearchRequestDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/notifications/search"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalNotificationsCustomerNotificationSearchRequestDto,
    }, options);
};
/**
 * Returns target collection
 * @summary customers/notifications/targets
 */
export var getCustomersNotificationsTargets = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/notifications/targets", method: 'get', headers: headers }, options);
};
/**
 * Returns categories collection
 * @summary notificationCategories
 */
export var getNotificationCategories = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/notificationCategories", method: 'get', headers: headers, params: params }, options);
};
/**
 * Return single customer attribute by attribute type
 * @deprecated
 * @summary customers/{customerId}/customerAttributes/{customerAttributeTypeId}
 */
export var getCustomerCustomerAttributeDeprecated = function (client, customerId, customerAttributeTypeId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/customerAttributes/").concat(customerAttributeTypeId),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * Updates single customer attribute by attribute type
 * @deprecated
 * @summary customers/{customerId}/customerAttributes/{customerAttributeTypeId}
 */
export var updateCustomerCustomerAttributeDeprecated = function (client, customerId, customerAttributeTypeId, globalCustomersAttributeDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/customerAttributes/").concat(customerAttributeTypeId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersAttributeDto,
    }, options);
};
/**
 * Gets all customer attributes
 * @deprecated
 * @summary customers/{customerId}/customerAttributes
 */
export var getCustomerCustomerAttributesDeprecated = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/customerAttributes"), method: 'get', headers: headers }, options);
};
/**
 * GET: Get list of chosen products of the offer
 * @summary shoppingSessions/{sessionId}/offers/{offerId}/choices
 */
export var getShoppingSessionOfferChoices = function (client, sessionId, offerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/offers/").concat(offerId, "/choices"), method: 'get', headers: headers }, options);
};
/**
 * PUT: Update chosen products of the offer
 * @summary shoppingSessions/{sessionId}/offers/{offerId}/choices
 */
export var updateShoppingSessionOfferChoices = function (client, sessionId, offerId, globalShoppingOfferChoicesDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/offers/").concat(offerId, "/choices"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingOfferChoicesDto,
    }, options);
};
/**
 * DELETE: Remove all chosen products of the offer
 * @summary shoppingSessions/{sessionId}/offers/{offerId}/choices
 */
export var deleteShoppingSessionOfferChoices = function (client, sessionId, offerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/offers/").concat(offerId, "/choices"), method: 'delete', headers: headers }, options);
};
/**
 * POST: Add new chosen offer item
 * @summary shoppingSessions/{sessionId}/offers/{offerId}/choices
 */
export var createShoppingSessionOfferChoice = function (client, sessionId, offerId, globalShoppingOfferChoiceDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/offers/").concat(offerId, "/choices"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingOfferChoiceDtoBody,
    }, options);
};
/**
 * GET: Get chosen offer item by product code
 * @summary shoppingSessions/{sessionId}/offers/{offerId}/choices/{itemCode}
 */
export var getShoppingSessionOfferChoice = function (client, sessionId, offerId, itemCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/offers/").concat(offerId, "/choices/").concat(itemCode),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * PUT: Modify requested quantity of chosen offer item
 * @summary shoppingSessions/{sessionId}/offers/{offerId}/choices/{itemCode}
 */
export var updateShoppingSessionOfferChoice = function (client, sessionId, offerId, itemCode, globalShoppingOfferChoiceDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/offers/").concat(offerId, "/choices/").concat(itemCode),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingOfferChoiceDtoBody,
    }, options);
};
/**
 * DELETE: Remove previously chosen offer item
 * @summary shoppingSessions/{sessionId}/offers/{offerId}/choices/{itemCode}
 */
export var deleteShoppingSessionOfferChoice = function (client, sessionId, offerId, itemCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/offers/").concat(offerId, "/choices/").concat(itemCode),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * GET: Get list of offered products
 * @summary shoppingSessions/{sessionId}/offers/{offerId}/offerItems
 */
export var getShoppingSessionOfferOfferItems = function (client, sessionId, offerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/offers/").concat(offerId, "/offerItems"),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
/**
 * GET: Get list of shopping offers evaluated for current shopping bag
 * @summary shoppingSessions/{sessionId}/offers
 */
export var getShoppingSessionOffers = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/offers"), method: 'get', headers: headers }, options);
};
/**
 * GET: Returns data for onboarding
 * @summary customers/{customerId}/onboarding
 */
export var getCustomerOnboarding = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/onboarding"), method: 'get', headers: headers }, options);
};
/**
 * PUT: Submits data for onboarding process
 * @summary customers/{customerId}/onboarding
 */
export var updateCustomerOnboarding = function (client, customerId, globalOnboardingOnboardingDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/onboarding"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalOnboardingOnboardingDto,
    }, options);
};
/**
 * GET: Returns metadata information about onboarding
 * @summary customers/{customerId}/onboardingMetadata
 */
export var getCustomerOnboardingMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/onboardingMetadata"), method: 'get', headers: headers }, options);
};
/**
 * GET: Provides information whether the customer has passed the onboarding test.
 * @summary customers/{customerId}/onboardingTest
 */
export var getCustomerOnboardingTest = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/onboardingTest"), method: 'get', headers: headers }, options);
};
/**
 * PUT: Provides the possibility to pass the onboarding test.
 * @summary customers/{customerId}/onboardingTest
 */
export var updateCustomerOnboardingTest = function (client, customerId, globalCustomersOnboardingTestDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/onboardingTest"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersOnboardingTestDto,
    }, options);
};
/**
 * Simulates behavior of a standard GET endpoint from Online API with authorization and without any further logic
 * @summary tests/smallSizeResponse/online
 */
export var getTestsSmallSizeResponseOnline = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tests/smallSizeResponse/online", method: 'get', headers: headers }, options);
};
/**
 * Simulates behavior of a standard GET endpoint from Online API with authorization and without any further logic
 * @summary tests/mediumSizeResponse/online
 */
export var getTestsMediumSizeResponseOnline = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tests/mediumSizeResponse/online", method: 'get', headers: headers }, options);
};
/**
 * Simulates behavior of a standard GET endpoint from Online API with authorization and without any further logic
 * @summary tests/bigSizeResponse/online
 */
export var getTestsBigSizeResponseOnline = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/tests/bigSizeResponse/online", method: 'get', headers: headers }, options);
};
/**
 * POST: Place new order
 * @summary shoppingSessions/{sessionId}/order
 */
export var createShoppingSessionOrder = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/order"), method: 'post', headers: headers }, options);
};
/**
 * GET:  Returns key performance indicators based on order history of the customer
Some information may be omitted based on market settings and customer type.
 * @summary applications/orderHistory/customers/{customerId}/kpi
 */
export var getApplicationsOrderHistoryCustomerKpi = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/orderHistory/customers/".concat(customerId, "/kpi"), method: 'get', headers: headers }, options);
};
/**
 * GET: Configuration for Order history
 * @summary applications/orderHistory/customers/{customerId}/configuration
 */
export var getApplicationsOrderHistoryCustomerConfiguration = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/orderHistory/customers/".concat(customerId, "/configuration"),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * Returns order items for given orders from one customer.
 * @summary orderItems
 */
export var getOrderItems = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orderItems", method: 'get', headers: headers, params: params }, options);
};
/**
 * Gets a list of orders for a specified customerId, with the possibility of filtering only desired status, and paging.
You can additionally filter by a search phrase, and choose to include WeChat orders.
History type switches between returning orders in the Current + past 3 periods; or the entire history (2 years).

If paging parameters are not provided, no paging is applied and full history for given time period is returned.
 * @summary orders
 */
export var getOrders = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders", method: 'get', headers: headers, params: params }, options);
};
/**
 * Place new order
 * @summary orders
 */
export var createOrder = function (client, globalShoppingOrderDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/orders",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingOrderDto,
    }, options);
};
/**
 * GET: Get specific order of a customer
 * @summary orders/{orderId}
 */
export var getOrder = function (client, orderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders/".concat(orderId), method: 'get', headers: headers }, options);
};
/**
 * DELETE : cancel order if cancellation is allowed
 * @summary orders/{orderId}
 */
export var deleteOrder = function (client, orderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders/".concat(orderId), method: 'delete', headers: headers }, options);
};
/**
 * GET: Get operation principals
 * @summary orders/{orderId}/operationPrincipals
 */
export var getOrderOperationPrincipals = function (client, orderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders/".concat(orderId, "/operationPrincipals"), method: 'get', headers: headers }, options);
};
/**
 * GET: Get last unpaid order for specific customer
 * @summary customers/{customerId}/orders/lastUnpaid
 */
export var getCustomerOrdersLastUnpaid = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/orders/lastUnpaid"), method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Provide availability of order cancel operation
 * @summary orders/{orderId}/cancellation
 */
export var getOrderCancellation = function (client, orderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders/".concat(orderId, "/cancellation"), method: 'get', headers: headers }, options);
};
/**
 * GET: Get realtime order trackings
 * @summary orders/{orderId}/realtimeOrderTracking
 */
export var getOrderRealtimeOrderTracking = function (client, orderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders/".concat(orderId, "/realtimeOrderTracking"), method: 'get', headers: headers }, options);
};
/**
 * GET: Provide selected payment provider
 * @summary orders/{orderId}/paymentProvider
 */
export var getOrderPaymentProvider = function (client, orderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders/".concat(orderId, "/paymentProvider"), method: 'get', headers: headers }, options);
};
/**
 * PUT: Update selected payment provider
 * @summary orders/{orderId}/paymentProvider
 */
export var updateOrderPaymentProvider = function (client, orderId, globalShoppingOrderPaymentProviderDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/orders/".concat(orderId, "/paymentProvider"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingOrderPaymentProviderDto,
    }, options);
};
/**
 * Returns a list of all discounts applied to the order.
 * @summary orders/{orderId}/discounts
 */
export var getOrderDiscounts = function (client, orderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders/".concat(orderId, "/discounts"), method: 'get', headers: headers }, options);
};
/**
 * GET: Gets the collection of all end consumers from a given order.
 * @summary orders/{orderId}/endConsumers
 */
export var getOrderEndConsumers = function (client, orderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders/".concat(orderId, "/endConsumers"), method: 'get', headers: headers }, options);
};
/**
 * Returns a list of order statuses and the total sum of orders per each status.
 * @summary orderStatuses
 */
export var getOrderStatuses = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orderStatuses", method: 'get', headers: headers, params: params }, options);
};
/**
 * Returns order navigation information (e.g. order detail page URL)
 * @summary orders/{orderId}/navigation
 */
export var getOrderNavigation = function (client, orderId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders/".concat(orderId, "/navigation"), method: 'get', headers: headers, params: params }, options);
};
/**
 * GET:  Returns financial aggregates for a given order such as debt, fees, discounts and BPs.
Some information may be omitted based on market settings and customer type.
 * @summary applications/orderSummary/orders/{orderId}/summary
 */
export var getApplicationsOrderSummaryOrderSummary = function (client, orderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/orderSummary/orders/".concat(orderId, "/summary"), method: 'get', headers: headers }, options);
};
/**
 * GET: Returns customer oriflame card in PDF format
 * @summary customers/{customerId}/oriflameCard
 */
export var getCustomerOriflameCard = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/oriflameCard"), method: 'get', headers: headers, params: params }, options);
};
/**
 * Get OutdatedBrowserInfo localization.
 * @summary applications/outdatedBrowserInfo/localization
 */
export var getApplicationsOutdatedBrowserInfoLocalization = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/outdatedBrowserInfo/localization", method: 'get', headers: headers }, options);
};
/**
 * GET: Provides payment methods
 * @summary orders/{orderId}/paymentMethods
 */
export var getOrderPaymentMethods = function (client, orderId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders/".concat(orderId, "/paymentMethods"), method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Provides payment methods
 * @summary shoppingSessions/{sessionId}/paymentMethods
 */
export var getShoppingSessionPaymentMethods = function (client, sessionId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/paymentMethods"), method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Provides payment providers
 * @summary shoppingSessions/{sessionId}/paymentProviders
 */
export var getShoppingSessionPaymentProviders = function (client, sessionId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/paymentProviders"), method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Provides payment provider
 * @summary shoppingSessions/{sessionId}/paymentProviders/{paymentProviderId}
 */
export var getShoppingSessionPaymentProvider = function (client, sessionId, paymentProviderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/paymentProviders/").concat(paymentProviderId),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * GET: Get payment provider
 * @summary paymentProviders/{paymentProviderId}
 */
export var getPaymentProvider = function (client, paymentProviderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/paymentProviders/".concat(paymentProviderId), method: 'get', headers: headers }, options);
};
/**
 * GET: Provides payment providers
 * @summary orders/{orderId}/paymentProviders
 */
export var getOrderPaymentProviders = function (client, orderId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders/".concat(orderId, "/paymentProviders"), method: 'get', headers: headers, params: params }, options);
};
/**
 * POST: Initialization of the online payment process, returns the parameters that are needed for further processing by the payment provider
 * @summary customer/{customerId}/order/{orderId}/paymentData
 */
export var createCustomerOrderPaymentDatum = function (client, customerId, orderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customer/".concat(customerId, "/order/").concat(orderId, "/paymentData"), method: 'post', headers: headers }, options);
};
/**
 * POST: Initialization of the shared online payment process, returns the parameters that are needed for further processing by the payment provider
 * @summary customer/{customerId}/order/{orderId}/sharedPaymentData
 */
export var createCustomerOrderSharedPaymentDatum = function (client, customerId, orderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customer/".concat(customerId, "/order/").concat(orderId, "/sharedPaymentData"), method: 'post', headers: headers }, options);
};
/**
 * GET: Provide selected payment
 * @summary shoppingSessions/{sessionId}/payment
 */
export var getShoppingSessionPayment = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/payment"), method: 'get', headers: headers }, options);
};
/**
 * PUT: Update selected payment
 * @summary shoppingSessions/{sessionId}/payment
 */
export var updateShoppingSessionPayment = function (client, sessionId, globalShoppingPaymentDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/payment"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingPaymentDto,
    }, options);
};
/**
 * GET: Returns result of evaluation if the order can be paid and number of pending payments
 * @summary orders/{orderId}/pendingPaymentsResult
 */
export var getOrderPendingPaymentsResult = function (client, orderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/orders/".concat(orderId, "/pendingPaymentsResult"), method: 'get', headers: headers }, options);
};
/**
 * GET: Returns pending registration
 * @summary pendingRegistrations/{pendingRegistrationId}
 */
export var getPendingRegistration = function (client, pendingRegistrationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/pendingRegistrations/".concat(pendingRegistrationId), method: 'get', headers: headers }, options);
};
/**
 * PUT: Updates pending registration
 * @summary pendingRegistrations/{pendingRegistrationId}
 */
export var updatePendingRegistration = function (client, pendingRegistrationId, globalPendingRegistrationsPendingRegistrationDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/pendingRegistrations/".concat(pendingRegistrationId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalPendingRegistrationsPendingRegistrationDtoBody,
    }, options);
};
/**
 * POST: Creates new pending registration
 * @summary pendingRegistrations
 */
export var createPendingRegistration = function (client, globalPendingRegistrationsPendingRegistrationDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/pendingRegistrations",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalPendingRegistrationsPendingRegistrationDtoBody,
    }, options);
};
/**
 * GET: Returns settings and metadata for pending registration
 * @summary pendingRegistrationsMetadata
 */
export var getPendingRegistrationsMetadata = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/pendingRegistrationsMetadata", method: 'get', headers: headers }, options);
};
/**
 * GET period information based on given period code
 * @summary periods/{periodCode}
 */
export var getPeriod = function (client, periodCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/periods/".concat(periodCode), method: 'get', headers: headers }, options);
};
/**
 * GET periods information based on given offsets
 * @summary periods
 */
export var getPeriods = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/periods", method: 'get', headers: headers, params: params }, options);
};
/**
 * GET current period information
 * @summary periods/currentPeriod
 */
export var getPeriodsCurrentPeriod = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/periods/currentPeriod", method: 'get', headers: headers }, options);
};
/**
 * GET: Provide status of period tasks
 * @summary periods/{periodCode}/tasks
 */
export var getPeriodTasks = function (client, periodCode, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/periods/".concat(periodCode, "/tasks"), method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: provide status of period task
 * @summary periods/{periodCode}/tasks/{taskId}
 */
export var getPeriodTask = function (client, periodCode, taskId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/periods/".concat(periodCode, "/tasks/").concat(taskId), method: 'get', headers: headers }, options);
};
/**
 * POST: Returns concepts permissions
 * @summary concepts/permissions
 */
export var getConceptsPermissions = function (client, globalConceptsPermissionsQueryDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/concepts/permissions",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalConceptsPermissionsQueryDtoBody,
    }, options);
};
/**
 * GET: Provides concept permissions
 * @summary concepts/{conceptCode}/permission
 */
export var getConceptPermission = function (client, conceptCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/concepts/".concat(conceptCode, "/permission"), method: 'get', headers: headers }, options);
};
/**
 * POST: Returns concepts permissions
 * @summary customers/{customerId}/concepts/permissions
 */
export var getCustomerConceptsPermissions = function (client, customerId, globalConceptsPermissionsQueryDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/concepts/permissions"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalConceptsPermissionsQueryDtoBody,
    }, options);
};
/**
 * GET: Provides concept permissions
 * @summary customers/{customerId}/concepts/{conceptCode}/permission
 */
export var getCustomerConceptPermission = function (client, customerId, conceptCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/concepts/").concat(conceptCode, "/permission"), method: 'get', headers: headers }, options);
};
/**
 * POST: Returns products permissions
 * @summary products/permissions
 */
export var getProductsPermissions = function (client, globalProductsPermissionsQueryDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/products/permissions",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalProductsPermissionsQueryDtoBody,
    }, options);
};
/**
 * GET: Provides product permissions
 * @summary products/{productCode}/permission
 */
export var getProductPermission = function (client, productCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/products/".concat(productCode, "/permission"), method: 'get', headers: headers }, options);
};
/**
 * GET: Provides product permissions
 * @summary customers/{customerId}/products/{productCode}/permission
 */
export var getCustomerProductPermission = function (client, customerId, productCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/products/").concat(productCode, "/permission"), method: 'get', headers: headers }, options);
};
/**
 * POST: Returns products permissions
 * @summary customers/{customerId}/products/permissions
 */
export var getCustomerProductsPermissions = function (client, customerId, globalProductsPermissionsQueryDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/products/permissions"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalProductsPermissionsQueryDtoBody,
    }, options);
};
/**
 * Provides permissions for customer
 * @summary customer/{customerId}/roles/permissions
 */
export var getCustomerRolesPermissions = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customer/".concat(customerId, "/roles/permissions"), method: 'get', headers: headers }, options);
};
/**
 * GET: Personal Beauty Store information
 * @summary customers/{customerId}/personalBeautyStore
 */
export var getCustomerPersonalBeautyStore = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/personalBeautyStore"), method: 'get', headers: headers }, options);
};
/**
 * POST: Create Personal Beauty Store
 * @summary customers/{customerId}/personalBeautyStore
 */
export var createCustomerPersonalBeautyStore = function (client, customerId, globalCustomersPersonalBeautyStoreDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/personalBeautyStore"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersPersonalBeautyStoreDtoBody,
    }, options);
};
/**
 * PUT: Modify Personal Beauty Store
 * @summary customers/{customerId}/personalBeautyStore
 */
export var updateCustomerPersonalBeautyStore = function (client, customerId, globalCustomersPersonalBeautyStoreDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/personalBeautyStore"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersPersonalBeautyStoreDtoBody,
    }, options);
};
/**
 * GET: Checks if is allowed to create Personal Beauty Store
 * @summary customers/{customerId}/personalBeautyStore/metadata
 */
export var getCustomerPersonalBeautyStoreMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/personalBeautyStore/metadata"), method: 'get', headers: headers }, options);
};
/**
 * Gets PBS profile for the customer with given customer id
 * @summary customers/{customerId}/personalBeautyStore/profile
 */
export var getCustomerPersonalBeautyStoreProfile = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/personalBeautyStore/profile"), method: 'get', headers: headers }, options);
};
/**
 * Gets PBS store of customer's sponsor.
 * @summary customers/{customerId}/SponsorPersonalBeautyStore
 */
export var getCustomerSponsorPersonalBeautyStore = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/SponsorPersonalBeautyStore"), method: 'get', headers: headers }, options);
};
/**
 * Provides personal beauty store link
 * @summary customers/{customerId}/personalBeautyStore/dynamiclink
 */
export var getCustomerPersonalBeautyStoreDynamiclink = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/personalBeautyStore/dynamiclink"), method: 'get', headers: headers }, options);
};
/**
 * Get Personal Beauty Store configuration
 * @summary personalBeautyStoreConfiguration
 */
export var getPersonalBeautyStoreConfiguration = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/personalBeautyStoreConfiguration", method: 'get', headers: headers }, options);
};
/**
 * Get Personal Beauty Store details
 * @summary personalBeautyStores/{name}
 */
export var getPersonalBeautyStore = function (client, name, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/personalBeautyStores/".concat(name), method: 'get', headers: headers }, options);
};
/**
 * GET: Returns information about personal details of registration with given ID
 * @summary customerRegistrations/{registrationId}/personalDetails
 */
export var getCustomerRegistrationPersonalDetails = function (client, registrationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customerRegistrations/".concat(registrationId, "/personalDetails"), method: 'get', headers: headers }, options);
};
/**
 * PUT: Modifies information about personal details of registration with given ID
 * @summary customerRegistrations/{registrationId}/personalDetails
 */
export var updateCustomerRegistrationPersonalDetails = function (client, registrationId, globalCustomerRegistrationsRegistrationPersonalDetailsDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customerRegistrations/".concat(registrationId, "/personalDetails"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomerRegistrationsRegistrationPersonalDetailsDto,
    }, options);
};
/**
 * GET: Returns documents for personal document
 * @summary customers/{customerId}/personalDocument
 */
export var getCustomerPersonalDocument = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/personalDocument"), method: 'get', headers: headers }, options);
};
/**
 * PUT: Change documents for personal document (temporary document are submitted and will no longer be deleted)
 * @summary customers/{customerId}/personalDocument
 */
export var updateCustomerPersonalDocument = function (client, customerId, globalCustomersCustomerDocumentsDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/personalDocument"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersCustomerDocumentsDto,
    }, options);
};
/**
 * Get Personal Menu localization
 * @deprecated
 * @summary applications/personalMenu/localization
 */
export var getApplicationsPersonalMenuLocalizationDeprecated = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/personalMenu/localization", method: 'get', headers: headers }, options);
};
/**
 * Get personal menu data
 * @summary applications/personalMenu
 */
export var getApplicationsPersonalMenu = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/personalMenu", method: 'get', headers: headers, params: params }, options);
};
/**
 * Gets OriSales menu items which will be merged with Online ones in personal menu application.
 * @summary applications/personalMenu/orisalesMenu
 */
export var getApplicationsPersonalMenuOrisalesMenu = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/personalMenu/orisalesMenu", method: 'get', headers: headers }, options);
};
/**
 * GET: Get personal performance kpis
 * @summary customers/{customerId}/personalPerformance
 */
export var getCustomerPersonalPerformance = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/personalPerformance"), method: 'get', headers: headers, params: params }, options);
};
/**
 * Gets the localization.
 * @summary applications/personalProductsList/localization
 */
export var getApplicationsPersonalProductsListLocalization = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/personalProductsList/localization", method: 'get', headers: headers }, options);
};
/**
 * Gets the configuration.
 * @summary applications/personalProductsList/configuration
 */
export var getApplicationsPersonalProductsListConfiguration = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/personalProductsList/configuration", method: 'get', headers: headers }, options);
};
/**
 * GET: Gets the telephones of customer with given customer id
 * @summary customers/{customerId}/phones
 */
export var getCustomerPhones = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/phones"), method: 'get', headers: headers }, options);
};
/**
 * POST: Creates a telephone for given customer id
 * @summary customers/{customerId}/phones
 */
export var createCustomerPhone = function (client, customerId, globalCustomersPhoneDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/phones"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersPhoneDtoBody,
    }, options);
};
/**
 * PUT: Updates the telephone with given telephone id
 * @summary customers/{customerId}/phones/{telephoneId}
 */
export var updateCustomerPhone = function (client, customerId, telephoneId, globalCustomersPhoneDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/phones/").concat(telephoneId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersPhoneDtoBody,
    }, options);
};
/**
 * DELETE: Deletes a telephone with given telephone id
 * @summary customers/{customerId}/phones/{telephoneId}
 */
export var deleteCustomerPhone = function (client, customerId, telephoneId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/phones/").concat(telephoneId), method: 'delete', headers: headers }, options);
};
/**
 * GET: Gets metadata information for phone endpoints of the customer with given customer id
 * @summary customers/{customerId}/phonesMetadata
 */
export var getCustomerPhonesMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/phonesMetadata"), method: 'get', headers: headers }, options);
};
/**
 * GET: Gets the status of verification process for given telephone id and customer id
 * @summary customers/{customerId}/phones/{telephoneId}/verificationRequest
 */
export var getCustomerPhoneVerificationRequest = function (client, customerId, telephoneId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/phones/").concat(telephoneId, "/verificationRequest"),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * PUT: Requests resending verification code for customer with a given telephone id and customer id
 * @summary customers/{customerId}/phones/{telephoneId}/verificationRequest
 */
export var updateCustomerPhoneVerificationRequest = function (client, customerId, telephoneId, globalCustomersTelephoneVerificationRequestDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/phones/").concat(telephoneId, "/verificationRequest"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersTelephoneVerificationRequestDto,
    }, options);
};
/**
 * Returns collection of popular product for chosen type and related category.
 * @summary popularProducts
 */
export var getPopularProducts = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/popularProducts", method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Returns preferences
 * @summary customers/{customerId}/preferences
 */
export var getCustomerPreferences = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/preferences"), method: 'get', headers: headers }, options);
};
/**
 * PUT: Change preferences values
 * @summary customers/{customerId}/preferences
 */
export var updateCustomerPreferences = function (client, customerId, globalCustomersCustomerPreferencesDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/preferences"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersCustomerPreferencesDto,
    }, options);
};
/**
 * GET: Returns metadata for preferences
 * @summary customers/{customerId}/preferencesMetadata
 */
export var getCustomerPreferencesMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/preferencesMetadata"), method: 'get', headers: headers }, options);
};
/**
 * GET: Returns prerequisites for checkout process
 * @summary customers/{customerId}/checkoutPrerequisites
 */
export var getCustomerCheckoutPrerequisites = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/checkoutPrerequisites"), method: 'get', headers: headers }, options);
};
/**
 * POST: Provides information about concept price
 * @summary concepts/prices
 */
export var getConceptsPrices = function (client, globalConceptsConceptPricesQueryDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/concepts/prices",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalConceptsConceptPricesQueryDtoBody,
    }, options);
};
/**
 * GET: Provides information about concept price
 * @summary concepts/{conceptCode}/price
 */
export var getConceptPrice = function (client, conceptCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/concepts/".concat(conceptCode, "/price"), method: 'get', headers: headers }, options);
};
/**
 * POST: Provides information about concept price
 * @summary customers/{customerId}/concepts/prices
 */
export var getCustomerConceptsPrices = function (client, customerId, globalConceptsConceptPricesQueryDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/concepts/prices"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalConceptsConceptPricesQueryDtoBody,
    }, options);
};
/**
 * GET: Provides information about concept price
 * @summary customers/{customerId}/concepts/{conceptCode}/price
 */
export var getCustomerConceptPrice = function (client, customerId, conceptCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/concepts/").concat(conceptCode, "/price"), method: 'get', headers: headers }, options);
};
/**
 * POST: Provides information about product price
 * @summary products/prices
 */
export var getProductsPrices = function (client, globalProductsProductPricesQueryDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/products/prices",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalProductsProductPricesQueryDtoBody,
    }, options);
};
/**
 * GET: Provides information about product price
 * @summary customers/{customerId}/products/{productCode}/price
 */
export var getCustomerProductPrice = function (client, customerId, productCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/products/").concat(productCode, "/price"), method: 'get', headers: headers }, options);
};
/**
 * POST: Provides information about product price
 * @summary customers/{customerId}/products/prices
 */
export var getCustomerProductsPrices = function (client, customerId, globalProductsProductPricesQueryDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/products/prices"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalProductsProductPricesQueryDtoBody,
    }, options);
};
/**
 * Gets single product bundle by product code
 * @summary productBundles/{productCode}
 */
export var getProductBundle = function (client, productCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/productBundles/".concat(productCode), method: 'get', headers: headers }, options);
};
/**
 * Gets collection of product bundles
 * @summary productBundles
 */
export var getProductBundles = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/productBundles", method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Provides collection of Product Labels' contents.
 * @summary productLabelsContent
 */
export var getProductLabelsContent = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/productLabelsContent", method: 'get', headers: headers }, options);
};
/**
 * GET: Get product list specified by productListId.
 * @summary productListTypes/{productListType}/productLists/{productListId}
 */
export var getProductListTypeProductList = function (client, productListType, productListId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/productListTypes/".concat(productListType, "/productLists/").concat(productListId),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * GET: Gets all product lists for specified customer of specified productListType.
 * @summary customers/{customerId}/productListTypes/{productListType}/productLists
 */
export var getCustomerProductListTypeProductLists = function (client, customerId, productListType, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/productListTypes/").concat(productListType, "/productLists"),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * POST: Creates new product list for specified customer of provided productListType.
 * @summary customers/{customerId}/productListTypes/{productListType}/productLists
 */
export var createCustomerProductListTypeProductList = function (client, customerId, productListType, globalSharedProductListDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/productListTypes/").concat(productListType, "/productLists"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalSharedProductListDtoBody,
    }, options);
};
/**
 * Gets one product list of type productListType specified by productListId.
 * @summary customers/{customerId}/productListTypes/{productListType}/productLists/{productListId}
 */
export var getCustomerProductListTypeProductList = function (client, customerId, productListType, productListId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/productListTypes/").concat(productListType, "/productLists/").concat(productListId),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * Updates  product list of type productListType specified by productListId.
 * @summary customers/{customerId}/productListTypes/{productListType}/productLists/{productListId}
 */
export var updateCustomerProductListTypeProductList = function (client, customerId, productListType, productListId, globalSharedProductListDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/productListTypes/").concat(productListType, "/productLists/").concat(productListId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalSharedProductListDtoBody,
    }, options);
};
/**
 * Delete product list of type productListType specified by productListId.
 * @summary customers/{customerId}/productListTypes/{productListType}/productLists/{productListId}
 */
export var deleteCustomerProductListTypeProductList = function (client, customerId, productListType, productListId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/productListTypes/").concat(productListType, "/productLists/").concat(productListId),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * Deletes product item of specified code from product list.
 * @summary customers/{customerId}/ProductListTypes/{productListType}/ProductLists/{productListId}/Items/{itemCode}
 */
export var deleteCustomerProductListTypeProductListItem = function (client, customerId, productListType, productListId, itemCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/ProductListTypes/").concat(productListType, "/ProductLists/").concat(productListId, "/Items/").concat(itemCode),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * Add one item of specified item code to product list.
 * @summary customers/{customerId}/ProductListTypes/{productListType}/ProductLists/{productListId}/Items
 */
export var createCustomerProductListTypeProductListItem = function (client, customerId, productListType, productListId, globalSharedProductListItemDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/ProductListTypes/").concat(productListType, "/ProductLists/").concat(productListId, "/Items"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalSharedProductListItemDto,
    }, options);
};
/**
 * Provides personal product list link.
 * @summary customers/{customerId}/productListTypes/{productListType}/productLists/{productListId}/dynamiclink
 */
export var getCustomerProductListTypeProductListDynamiclink = function (client, customerId, productListId, headers, params, productListType, options) {
    if (productListType === void 0) { productListType = 'Personal'; }
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/productListTypes/").concat(productListType, "/productLists/").concat(productListId, "/dynamiclink"),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
/**
 * GET: Get product listing specified by productListingPageId
 * @summary applications/productListing/listings
 */
export var getApplicationsProductListingListings = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/productListing/listings", method: 'get', headers: headers, params: params }, options);
};
/**
 * Provides collection of Product Listing Promo Banners
 * @summary applications/productListing/promoBanners
 */
export var getApplicationsProductListingPromoBanners = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/productListing/promoBanners", method: 'get', headers: headers, params: params }, options);
};
/**
 * POST: Provides products
 * @summary products
 */
export var getProducts = function (client, globalProductsQueryDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/products",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalProductsQueryDto,
    }, options);
};
/**
 * GET: Provides product
 * @summary products/{productCode}
 */
export var getProduct = function (client, productCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/products/".concat(productCode), method: 'get', headers: headers }, options);
};
/**
 * Gets the products expected inbounds
 * @summary productsExpectedInbounds
 */
export var getProductsExpectedInbounds = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/productsExpectedInbounds", method: 'get', headers: headers, params: params }, options);
};
/**
 * Gets the products ingredients
 * @summary productsIngredients
 */
export var getProductsIngredients = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/productsIngredients", method: 'get', headers: headers, params: params }, options);
};
/**
 * Gets collection of product labels for anonymous customer.
 * @summary productsLabels
 */
export var getProductsLabels = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/productsLabels", method: 'get', headers: headers, params: params }, options);
};
/**
 * Gets products replacements for specific customer.
 * @summary customers/{customerId}/productsReplacements
 */
export var getCustomerProductsReplacements = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/productsReplacements"), method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Collection of products by search criteria
 * @summary applications/shoppingBag/products
 */
export var getApplicationsShoppingBagProducts = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/shoppingBag/products", method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Gets the customer profile of the customer with given customer id
 * @summary customers/{customerId}/profile
 */
export var getCustomerProfile = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/profile"), method: 'get', headers: headers }, options);
};
/**
 * PUT: Updates the customer profile of the customer with given customer id
 * @summary customers/{customerId}/profile
 */
export var updateCustomerProfile = function (client, customerId, globalCustomersProfileDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/profile"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersProfileDto,
    }, options);
};
/**
 * GET: Gets metadata information for profile endpoints of the customer with given customer id
 * @summary customers/{customerId}/profileMetadata
 */
export var getCustomerProfileMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/profileMetadata"), method: 'get', headers: headers }, options);
};
/**
 * GET: Gets information about completeness of user's profile
 * @summary customers/{customerId}/profileCompleteness
 */
export var getCustomerProfileCompleteness = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/profileCompleteness"), method: 'get', headers: headers }, options);
};
/**
 * GET: Gets configuration for user's profile completeness
 * @summary customers/{customerId}/profileCompletenessMetadata
 */
export var getCustomerProfileCompletenessMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/profileCompletenessMetadata"), method: 'get', headers: headers }, options);
};
/**
 * GET: Configuration for profile sections for customer
 * @summary customers/{customerId}/applications/profile/configurations/sections
 */
export var getCustomerApplicationsProfileConfigurationsSections = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/applications/profile/configurations/sections"),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * Returns information about all profile approvals for customer
 * @summary customers/{customerId}/profileApproval
 */
export var getCustomerProfileApproval = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/profileApproval"), method: 'get', headers: headers }, options);
};
/**
 * GET: Returns document for profile image
 * @summary customers/{customerId}/profileImage
 */
export var getCustomerProfileImage = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/profileImage"), method: 'get', headers: headers }, options);
};
/**
 * PUT: Change documents for profile image (temporary document are submitted and will no longer be deleted)
 * @summary customers/{customerId}/profileImage
 */
export var updateCustomerProfileImage = function (client, customerId, globalCustomersProfileImageDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/profileImage"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersProfileImageDto,
    }, options);
};
/**
 * GET: Returns metadata for profile image
 * @summary customers/{customerId}/profileImageMetadata
 */
export var getCustomerProfileImageMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/profileImageMetadata"), method: 'get', headers: headers }, options);
};
/**
 * Provide a specific promotion
 * @summary promotions/{promotionId}
 */
export var getPromotion = function (client, promotionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/promotions/".concat(promotionId), method: 'get', headers: headers }, options);
};
/**
 * Gets best offers banners
 * @summary promotionBestOffersBanners
 */
export var getPromotionBestOffersBanners = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/promotionBestOffersBanners", method: 'get', headers: headers, params: params }, options);
};
/**
 * Gets whats new type banners
 * @summary promotionWhatsNewBanners
 */
export var getPromotionWhatsNewBanners = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/promotionWhatsNewBanners", method: 'get', headers: headers, params: params }, options);
};
/**
 * Gets hero banners
 * @summary promotionHeroBanners
 */
export var getPromotionHeroBanners = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/promotionHeroBanners", method: 'get', headers: headers, params: params }, options);
};
/**
 * Gets campaign banners
 * @summary promotionCampaignBanners
 */
export var getPromotionCampaignBanners = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/promotionCampaignBanners", method: 'get', headers: headers, params: params }, options);
};
/**
 * Gets category banners
 * @summary promotionCategoryBanners
 */
export var getPromotionCategoryBanners = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/promotionCategoryBanners", method: 'get', headers: headers, params: params }, options);
};
/**
 * Gets current promotions
 * @summary digitalPromotions
 */
export var getDigitalPromotions = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/digitalPromotions", method: 'get', headers: headers, params: params }, options);
};
/**
 * Provide all valid promotions
 * @summary promotions
 */
export var getPromotions = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/promotions", method: 'get', headers: headers }, options);
};
/**
 * Creates or updates push notification installation for anonymous customer
 * @summary pushNotifications/installations
 */
export var createPushNotificationsInstallation = function (client, globalNotificationsInstallationRequestDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/pushNotifications/installations",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalNotificationsInstallationRequestDtoBody,
    }, options);
};
/**
 * Creates or updates push notification installation for logged in customer
 * @summary customers/{customerId}/pushNotifications/installations
 */
export var createCustomerPushNotificationsInstallation = function (client, customerId, globalNotificationsInstallationRequestDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/pushNotifications/installations"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalNotificationsInstallationRequestDtoBody,
    }, options);
};
/**
 * Deletes installation
 * @summary customers/{customerId}/pushNotifications/installations/{installationId}
 */
export var deleteCustomerPushNotificationsInstallation = function (client, customerId, installationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/pushNotifications/installations/").concat(installationId),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * Create or update device registration in Push notification center to possible to deliver the push notification to this device.
            
Deprecated for Cumulus Markets: Please use route /pushNotifications/installations or /customers/{customerId}/pushNotifications/installations instead
 * @summary pushNotifications/registrations
 */
export var createPushNotificationsRegistration = function (client, globalNotificationsPushRegistrationDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/pushNotifications/registrations",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalNotificationsPushRegistrationDto,
    }, options);
};
/**
 * Unregister device from application by registration ID
            
Deprecated for Cumulus Markets
 * @summary pushNotifications/applications/{applicationKey}/registrationId/{registrationId}
 */
export var deletePushNotificationsApplicationRegistrationId = function (client, applicationKey, registrationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/pushNotifications/applications/".concat(applicationKey, "/registrationId/").concat(registrationId),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * Unregister device from application by device token
            
Deprecated for Cumulus Markets
 * @summary pushNotifications/applications/{applicationKey}/deviceToken/{deviceToken}
 */
export var deletePushNotificationsApplicationDeviceToken = function (client, applicationKey, deviceToken, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/pushNotifications/applications/".concat(applicationKey, "/deviceToken/").concat(deviceToken),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * GET: Localization for RealTime Order Tracking application
 * @summary applications/realTimeOrderTracking/localization
 */
export var getApplicationsRealTimeOrderTrackingLocalization = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/realTimeOrderTracking/localization", method: 'get', headers: headers }, options);
};
/**
 * Get stored payment cards
 * @summary customers/{customerId}/recurringPaymentCards
 */
export var getCustomerRecurringPaymentCards = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/recurringPaymentCards"), method: 'get', headers: headers, params: params }, options);
};
/**
 * Delete stored payment card
 * @summary customers/{customerId}/recurringPaymentCards/{recurringPaymentCardId}
 */
export var deleteCustomerRecurringPaymentCard = function (client, customerId, recurringPaymentCardId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/recurringPaymentCards/").concat(recurringPaymentCardId),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * GET: Gets metadata information for recurring payment card endpoints of the customer with given customer id
 * @summary customers/{customerId}/recurringPaymentCardsMetadata
 */
export var getCustomerRecurringPaymentCardsMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/recurringPaymentCardsMetadata"), method: 'get', headers: headers }, options);
};
/**
 * GET: Provide assigned referral
 * @summary shoppingSessions/{sessionId}/referral
 */
export var getShoppingSessionReferral = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/referral"), method: 'get', headers: headers }, options);
};
/**
 * POST: Assign referral invitation
 * @summary shoppingSessions/{sessionId}/referral
 */
export var createShoppingSessionReferral = function (client, sessionId, globalShoppingReferralDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/referral"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingReferralDto,
    }, options);
};
/**
 * POST: Performs consultant registration done by sponsor, SPO or customer service
 * @summary customers/{customerId}/consultants
 */
export var createCustomerConsultant = function (client, customerId, globalCustomersConsultantRegistrationDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/consultants"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersConsultantRegistrationDto,
    }, options);
};
/**
 * POST: Performs self registration for consultant
 * @summary consultants
 */
export var createConsultant = function (client, globalCustomersSelfRegistrationDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/consultants",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersSelfRegistrationDto,
    }, options);
};
/**
 * Return metadata for registration done by sponsor
 * @summary customers/{customerId}/consultantsMetadata
 */
export var getCustomerConsultantsMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/consultantsMetadata"), method: 'get', headers: headers }, options);
};
/**
 * Return metadata for registration done by sponsor
 * @summary consultantsMetadata
 */
export var getConsultantsMetadata = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/consultantsMetadata", method: 'get', headers: headers }, options);
};
/**
 * GET: Returns customer's registration info
 * @summary customers/{customerId}/registrationInfo
 */
export var getCustomerRegistrationInfo = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/registrationInfo"), method: 'get', headers: headers }, options);
};
/**
 * GET: Returns information about registration order for given customer
 * @summary customers/{customerId}/registrationOrder
 */
export var getCustomerRegistrationOrder = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/registrationOrder"), method: 'get', headers: headers }, options);
};
/**
 * POST: Creates order returns its ID
 * @summary customers/{customerId}/registrationOrder
 */
export var createCustomerRegistrationOrder = function (client, customerId, globalCustomersRegistrationOrderDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/registrationOrder"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersRegistrationOrderDto,
    }, options);
};
/**
 * GET: Returns information about registration with given ID
 * @summary customerRegistrations/{registrationId}
 */
export var getCustomerRegistration = function (client, registrationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customerRegistrations/".concat(registrationId), method: 'get', headers: headers }, options);
};
/**
 * PUT: Updates a registration
 * @summary customerRegistrations/{registrationId}
 */
export var updateCustomerRegistration = function (client, registrationId, globalCustomerRegistrationsRegistrationDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customerRegistrations/".concat(registrationId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomerRegistrationsRegistrationDtoBody,
    }, options);
};
/**
 * GET: Returns information about registration with given customer ID
 * @summary customerRegistrations/customers/{customerId}
 */
export var getCustomerRegistrationsCustomer = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customerRegistrations/customers/".concat(customerId), method: 'get', headers: headers }, options);
};
/**
 * POST: Creates a registration and returns its ID
 * @summary customerRegistrations
 */
export var createCustomerRegistration = function (client, globalCustomerRegistrationsRegistrationDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customerRegistrations",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomerRegistrationsRegistrationDtoBody,
    }, options);
};
/**
 * GET - Provides related product codes and relation types.
 * @summary products/{productCode}/relations
 */
export var getProductRelations = function (client, productCode, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/products/".concat(productCode, "/relations"), method: 'get', headers: headers, params: params }, options);
};
/**
 * Installs all SQL scripts for tenant environment. Old scripts are replaced.
 * @summary reporting/reports/install
 */
export var createReportingReportsInstall = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/reporting/reports/install", method: 'post', headers: headers }, options);
};
/**
 * Returns terms info and html content
 * @summary requiredTerms
 */
export var getRequiredTerms = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/requiredTerms", method: 'get', headers: headers, params: params }, options);
};
/**
 * POST: Creates new revolut account bound to provided IBAN
 * @summary revolutProfiles
 */
export var createRevolutProfile = function (client, globalFinanceRevolutProfileDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/revolutProfiles",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalFinanceRevolutProfileDto,
    }, options);
};
/**
 * GET: Get shopping bag sales
 * @summary shoppingSessions/{sessionId}/sales
 */
export var getShoppingSessionSales = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/sales"), method: 'get', headers: headers }, options);
};
/**
 * @summary salesmanagoClientData
 */
export var getSalesmanagoClientData = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/salesmanagoClientData", method: 'get', headers: headers }, options);
};
/**
 * GET: Get evaluated section items
 * @summary shoppingSessions/{sessionId}/sections/{sectionId}/sectionItems
 */
export var getShoppingSessionSectionSectionItems = function (client, sessionId, sectionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/sections/").concat(sectionId, "/sectionItems"),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * GET: Get list of shopping sections evaluated for current shopping bag
 * @summary shoppingSessions/{sessionId}/sections
 */
export var getShoppingSessionSections = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/sections"), method: 'get', headers: headers }, options);
};
/**
 * GET: Provide suggested product codes (max. 10 results is provided)
 * @summary shoppingSessions/{sessionId}/sectionSuggestions
 */
export var getShoppingSessionSectionSuggestions = function (client, sessionId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/sectionSuggestions"), method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Get product wish-list of the section
 * @summary shoppingSessions/{sessionId}/sections/{sectionId}/wishlist
 */
export var getShoppingSessionSectionWishlistItems = function (client, sessionId, sectionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/sections/").concat(sectionId, "/wishlist"),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * DELETE: Remove all products from section wish-list
 * @summary shoppingSessions/{sessionId}/sections/{sectionId}/wishlist
 */
export var deleteShoppingSessionSectionWishlistItems = function (client, sessionId, sectionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/sections/").concat(sectionId, "/wishlist"),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * POST: Add product to section wish-list
 * @summary shoppingSessions/{sessionId}/sections/{sectionId}/wishlist
 */
export var createShoppingSessionSectionWishlist = function (client, sessionId, sectionId, globalShoppingSectionWishlistItemDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/sections/").concat(sectionId, "/wishlist"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingSectionWishlistItemDtoBody,
    }, options);
};
/**
 * GET: Get wish-list item by product code
 * @summary shoppingSessions/{sessionId}/sections/{sectionId}/wishlist/{itemCode}
 */
export var getShoppingSessionSectionWishlist = function (client, sessionId, sectionId, itemCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/sections/").concat(sectionId, "/wishlist/").concat(itemCode),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * PUT: Update product quantity in section wish-list
 * @summary shoppingSessions/{sessionId}/sections/{sectionId}/wishlist/{itemCode}
 */
export var updateShoppingSessionSectionWishlist = function (client, sessionId, sectionId, itemCode, globalShoppingSectionWishlistItemDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/sections/").concat(sectionId, "/wishlist/").concat(itemCode),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingSectionWishlistItemDtoBody,
    }, options);
};
/**
 * DELETE: Remove product from section wish-list
 * @summary shoppingSessions/{sessionId}/sections/{sectionId}/wishlist/{itemCode}
 */
export var deleteShoppingSessionSectionWishlist = function (client, sessionId, sectionId, itemCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/sections/").concat(sectionId, "/wishlist/").concat(itemCode),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * Get Network Communications configurations
 * @summary applications/networkCommunication/configuration
 */
export var getApplicationsNetworkCommunicationConfiguration = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/networkCommunication/configuration", method: 'get', headers: headers }, options);
};
/**
 * Get Network Communications localization
 * @summary applications/networkCommunication/localization
 */
export var getApplicationsNetworkCommunicationLocalization = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/networkCommunication/localization", method: 'get', headers: headers }, options);
};
/**
 * GET: Get selected free shipping product
 * @summary shoppingSessions/{sessionId}/shippingJokerChoice
 */
export var getShoppingSessionShippingJokerChoice = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/shippingJokerChoice"), method: 'get', headers: headers }, options);
};
/**
 * DELETE: Reset free shipping selection
 * @summary shoppingSessions/{sessionId}/shippingJokerChoice
 */
export var deleteShoppingSessionShippingJokerChoice = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/shippingJokerChoice"), method: 'delete', headers: headers }, options);
};
/**
 * POST: Apply free shipping product
 * @summary shoppingSessions/{sessionId}/shippingJokerChoice
 */
export var createShoppingSessionShippingJokerChoice = function (client, sessionId, globalShoppingShippingChoiceDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/shippingJokerChoice"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingShippingChoiceDto,
    }, options);
};
/**
 * GET: Get selected free shipping products
 * @summary shoppingSessions/{sessionId}/shippingJokerChoices
 */
export var getShoppingSessionShippingJokerChoices = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/shippingJokerChoices"), method: 'get', headers: headers }, options);
};
/**
 * DELETE: Reset free shipping selection
 * @summary shoppingSessions/{sessionId}/shippingJokerChoices
 */
export var deleteShoppingSessionShippingJokerChoices = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/shippingJokerChoices"), method: 'delete', headers: headers }, options);
};
/**
 * PUT: Apply free shipping products
 * @summary shoppingSessions/{sessionId}/shippingJokerChoices
 */
export var updateShoppingSessionShippingJokerChoices = function (client, sessionId, globalShoppingShippingChoicesDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/shippingJokerChoices"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingShippingChoicesDto,
    }, options);
};
/**
 * GET: Provides free shipping offers for selected or alternative delivery channel
 * @summary shoppingSessions/{sessionId}/shippingJokers
 */
export var getShoppingSessionShippingJokers = function (client, sessionId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/shippingJokers"), method: 'get', headers: headers, params: params }, options);
};
/**
 * POST: Saves the shopping bag.
 * @summary shoppingSessions/{sessionId}/shoppingBag
 */
export var createShoppingSessionShoppingBag = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/shoppingBag"), method: 'post', headers: headers }, options);
};
/**
 * DELETE: Clears a shopping bag (added products, selected offers and all other user inputs).
 * @summary shoppingSessions/{sessionId}/shoppingBag
 */
export var deleteShoppingSessionShoppingBag = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/shoppingBag"), method: 'delete', headers: headers }, options);
};
/**
 * GET: Get list of aggregated shopping bag items.
 * @summary shoppingSessions/{sessionId}/shoppingBag/aggregatedItems
 */
export var getShoppingSessionShoppingBagAggregatedItems = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/shoppingBag/aggregatedItems"), method: 'get', headers: headers }, options);
};
/**
 * PUT: Update quantity of a shopping bag item.
 * @summary shoppingSessions/{sessionId}/shoppingBag/bagItems/{bagItemId}
 */
export var updateShoppingSessionShoppingBagBagItem = function (client, sessionId, bagItemId, globalShoppingShoppingBagItemDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/shoppingBag/bagItems/").concat(bagItemId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingShoppingBagItemDto,
    }, options);
};
/**
 * DELETE: Remove a shopping bag item.
 * @summary shoppingSessions/{sessionId}/shoppingBag/bagItems/{bagItemId}
 */
export var deleteShoppingSessionShoppingBagBagItem = function (client, sessionId, bagItemId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/shoppingBag/bagItems/").concat(bagItemId),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * GET: Provide status of back-order demand.
 * @summary shoppingSessions/{sessionId}/shoppingBag/bagItems/{bagItemId}/backorder
 */
export var getShoppingSessionShoppingBagBagItemBackorder = function (client, sessionId, bagItemId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/shoppingBag/bagItems/").concat(bagItemId, "/backorder"),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * POST: Request to be out-of-stock product back-ordered.
 * @summary shoppingSessions/{sessionId}/shoppingBag/bagItems/{bagItemId}/backorder
 */
export var createShoppingSessionShoppingBagBagItemBackorder = function (client, sessionId, bagItemId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/shoppingBag/bagItems/").concat(bagItemId, "/backorder"),
        method: 'post',
        headers: headers,
    }, options);
};
/**
 * DELETE: Recall back-order demand.
 * @summary shoppingSessions/{sessionId}/shoppingBag/bagItems/{bagItemId}/backorder
 */
export var deleteShoppingSessionShoppingBagBagItemBackorder = function (client, sessionId, bagItemId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/shoppingBag/bagItems/").concat(bagItemId, "/backorder"),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * GET: Provide pending (not available) back-orders.
 * @summary shoppingSessions/{sessionId}/pendingBackorders
 */
export var getShoppingSessionPendingBackorders = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/pendingBackorders"), method: 'get', headers: headers }, options);
};
/**
 * POST: Adds a new item to the shopping bag.
 * @summary shoppingSessions/{sessionId}/shoppingBag/bagItems
 */
export var createShoppingSessionShoppingBagBagItem = function (client, sessionId, globalShoppingShoppingBagItemDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/shoppingBag/bagItems"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingShoppingBagItemDto,
    }, options);
};
/**
 * PUT: Update shopping bag items (remove all current items and add specified items)
 * @summary shoppingSessions/{sessionId}/shoppingBag/bagItems
 */
export var updateShoppingSessionShoppingBagBagItems = function (client, sessionId, globalShoppingShoppingBagItemDtoArrayBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/shoppingBag/bagItems"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingShoppingBagItemDtoArrayBody,
    }, options);
};
/**
 * PUT: Update shopping bag items (remove all current items and add specified items)
Returns object with current shopping bag items and summary
 * @summary applications/wechatpbs/shoppingSessions/{sessionId}/shoppingBag/bagItems
 */
export var updateApplicationsWechatpbsShoppingSessionShoppingBagBagItems = function (client, sessionId, globalShoppingShoppingBagItemDtoArrayBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/wechatpbs/shoppingSessions/".concat(sessionId, "/shoppingBag/bagItems"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingShoppingBagItemDtoArrayBody,
    }, options);
};
/**
 * GET: Provides campaign points balance
 * @summary shoppingSessions/{sessionId}/campaigns/{campaignId}/points
 */
export var getShoppingSessionCampaignPoints = function (client, sessionId, campaignId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/campaigns/").concat(campaignId, "/points"),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * GET: Get approved end-consumer orders
 * @summary shoppingSessions/{sessionId}/endConsumerOrders
 */
export var getShoppingSessionEndConsumerOrders = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/endConsumerOrders"), method: 'get', headers: headers }, options);
};
/**
 * DELETE: Unapproved end-consumer order to prevent dropping to consultant's basket
 * @summary shoppingSessions/{sessionId}/endConsumerOrders/{endConsumerOrderId}
 */
export var deleteShoppingSessionEndConsumerOrder = function (client, sessionId, endConsumerOrderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/endConsumerOrders/").concat(endConsumerOrderId),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * GET: Get items of end-consumer order
 * @summary shoppingSessions/{sessionId}/endConsumerOrders/{endConsumerOrderId}/items
 */
export var getShoppingSessionEndConsumerOrderItems = function (client, sessionId, endConsumerOrderId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/endConsumerOrders/").concat(endConsumerOrderId, "/items"),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * PUT: Modify number of purchased products in the end-consumer's order
 * @summary shoppingSessions/{sessionId}/endConsumerOrders/{endConsumerOrderId}/items/{itemCode}
 */
export var updateShoppingSessionEndConsumerOrderItem = function (client, sessionId, endConsumerOrderId, itemCode, globalShoppingEndConsumerOrderItemDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/endConsumerOrders/").concat(endConsumerOrderId, "/items/").concat(itemCode),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingEndConsumerOrderItemDto,
    }, options);
};
/**
 * DELETE: Delete product from end-consumer's order
 * @summary shoppingSessions/{sessionId}/endConsumerOrders/{endConsumerOrderId}/items/{itemCode}
 */
export var deleteShoppingSessionEndConsumerOrderItem = function (client, sessionId, endConsumerOrderId, itemCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/endConsumerOrders/").concat(endConsumerOrderId, "/items/").concat(itemCode),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * GET: Get list of shopping messages evaluated for current shopping bag
 * @summary shoppingSessions/{sessionId}/messages
 */
export var getShoppingSessionMessages = function (client, sessionId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/messages"), method: 'get', headers: headers, params: params }, options);
};
/**
 * POST: Starts new shopping session. Session expires after defined time of inactivity.
 * @summary shoppingSessions
 */
export var createShoppingSession = function (client, globalShoppingShoppingDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingShoppingDto,
    }, options);
};
/**
 * GET: Gets shopping session data. Also refreshes the session, so it will not expire.
 * @summary shoppingSessions/{sessionId}
 */
export var getShoppingSession = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId), method: 'get', headers: headers }, options);
};
/**
 * DELETE: Delete shopping session from Redis.
 * @summary shoppingSessions/{sessionId}
 */
export var deleteShoppingSession = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId), method: 'delete', headers: headers }, options);
};
/**
 * Creates the visit to social media entity.
 * @summary applications/socialMediaLibrary/customers/{customerId}/socialEntities/{entityId}/visit
 */
export var createApplicationsSocialMediaLibraryCustomerSocialEntityVisit = function (client, customerId, entityId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/socialMediaLibrary/customers/".concat(customerId, "/socialEntities/").concat(entityId, "/visit"),
        method: 'post',
        headers: headers,
    }, options);
};
/**
 * Creates like of social media entity.
 * @summary applications/socialMediaLibrary/customers/{customerId}/socialEntities/{entityId}/like
 */
export var createApplicationsSocialMediaLibraryCustomerSocialEntityLike = function (client, customerId, entityId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/socialMediaLibrary/customers/".concat(customerId, "/socialEntities/").concat(entityId, "/like"),
        method: 'post',
        headers: headers,
    }, options);
};
/**
 * Delete like of social media entity.
 * @summary applications/socialMediaLibrary/customers/{customerId}/socialEntities/{entityId}/like
 */
export var deleteApplicationsSocialMediaLibraryCustomerSocialEntityLike = function (client, customerId, entityId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/socialMediaLibrary/customers/".concat(customerId, "/socialEntities/").concat(entityId, "/like"),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * Gets all liked social entities of specified customer.
 * @summary applications/socialMediaLibrary/customers/{customerId}/SocialEntityLikes
 */
export var getApplicationsSocialMediaLibraryCustomerSocialEntityLikes = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/socialMediaLibrary/customers/".concat(customerId, "/SocialEntityLikes"),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * Gets the social entities statistics.
 * @summary applications/socialMediaLibrary/stats
 */
export var getApplicationsSocialMediaLibraryStats = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/socialMediaLibrary/stats", method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Get special offer evaluated by for current shopping bag
 * @summary shoppingSessions/{sessionId}/specialOffers/{offerId}
 */
export var getShoppingSessionSpecialOffer = function (client, sessionId, offerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/specialOffers/").concat(offerId), method: 'get', headers: headers }, options);
};
/**
 * GET: Get offer choice preferences selected by customer
 * @summary shoppingSessions/{sessionId}/specialOffers/{offerId}/choice
 */
export var getShoppingSessionSpecialOfferChoice = function (client, sessionId, offerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/specialOffers/").concat(offerId, "/choice"),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * PUT: Select offer, backorder or replacement
 * @summary shoppingSessions/{sessionId}/specialOffers/{offerId}/choice
 */
export var updateShoppingSessionSpecialOfferChoice = function (client, sessionId, offerId, globalShoppingSpecialOfferChoiceDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/specialOffers/").concat(offerId, "/choice"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingSpecialOfferChoiceDto,
    }, options);
};
/**
 * DELETE: Reset offer choice selection
 * @summary shoppingSessions/{sessionId}/specialOffers/{offerId}/choice
 */
export var deleteShoppingSessionSpecialOfferChoice = function (client, sessionId, offerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/specialOffers/").concat(offerId, "/choice"),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * GET: Get alternative products for a special offer
 * @summary shoppingSessions/{sessionId}/specialOffers/{offerId}/replacements
 */
export var getShoppingSessionSpecialOfferReplacements = function (client, sessionId, offerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/specialOffers/").concat(offerId, "/replacements"),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * GET: Get list of special offers evaluated for current shopping bag
 * @summary shoppingSessions/{sessionId}/specialOffers
 */
export var getShoppingSessionSpecialOffers = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/specialOffers"), method: 'get', headers: headers }, options);
};
/**
 * GET: Get offer voucher data and voucher items selected by customer
 * @summary shoppingSessions/{sessionId}/specialOffers/{offerId}/voucher
 */
export var getShoppingSessionSpecialOfferVoucher = function (client, sessionId, offerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/specialOffers/").concat(offerId, "/voucher"),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * POST: Add offer voucher choice selected by customer
 * @summary shoppingSessions/{sessionId}/specialOffers/{offerId}/voucher/choices
 */
export var createShoppingSessionSpecialOfferVoucherChoice = function (client, sessionId, offerId, globalShoppingSpecialOfferVoucherChoiceDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/specialOffers/").concat(offerId, "/voucher/choices"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingSpecialOfferVoucherChoiceDto,
    }, options);
};
/**
 * DELETE: Remove offer voucher choice selected by customer
 * @summary shoppingSessions/{sessionId}/specialOffers/{offerId}/voucher/choices/{choiceId}
 */
export var deleteShoppingSessionSpecialOfferVoucherChoice = function (client, sessionId, offerId, choiceId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/specialOffers/").concat(offerId, "/voucher/choices/").concat(choiceId),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * GET: Returns sponsor information of registration with given ID
 * @summary customerRegistrations/{registrationId}/sponsorDetails
 */
export var getCustomerRegistrationSponsorDetails = function (client, registrationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customerRegistrations/".concat(registrationId, "/sponsorDetails"), method: 'get', headers: headers }, options);
};
/**
 * PUT: Modifies sponsor information of registration with given ID
 * @summary customerRegistrations/{registrationId}/sponsorDetails
 */
export var updateCustomerRegistrationSponsorDetails = function (client, registrationId, globalCustomerRegistrationsRegistrationSponsorDetailsDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customerRegistrations/".concat(registrationId, "/sponsorDetails"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomerRegistrationsRegistrationSponsorDetailsDto,
    }, options);
};
/**
 * GET: Returns information about the sponsor selected in the simplified registration process
 * @summary customerRegistrations/{registrationId}/sponsorDetails/sponsorInfo
 */
export var getCustomerRegistrationSponsorDetailsSponsorInfo = function (client, registrationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customerRegistrations/".concat(registrationId, "/sponsorDetails/sponsorInfo"),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * GET: Returns profile image of selected sponsor
 * @summary customerRegistrations/{registrationId}/sponsorDetails/profileImage
 */
export var getCustomerRegistrationSponsorDetailsProfileImage = function (client, registrationId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customerRegistrations/".concat(registrationId, "/sponsorDetails/profileImage"),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * GET: Returns information about all sponsors for customer
 * @summary customers/{customerId}/sponsors
 */
export var getCustomerSponsors = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/sponsors"), method: 'get', headers: headers }, options);
};
/**
 * Provides steps to success tasks of specific customer
 * @summary customers/{customerId}/stepsToSuccess
 */
export var getCustomerStepsToSuccessTasks = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/stepsToSuccess"), method: 'get', headers: headers, params: params }, options);
};
/**
 * Provides steps to success tasks phases of specific customer
 * @summary customers/{customerId}/stepsToSuccessPhases
 */
export var getCustomerStepsToSuccessTasksPhases = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/stepsToSuccessPhases"), method: 'get', headers: headers, params: params }, options);
};
/**
 * Gets specific steps to success task of specific customer by id
 * @summary customers/{customerId}/stepsToSuccess/{taskId}
 */
export var getCustomerStepsToSuccessTask = function (client, customerId, taskId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/stepsToSuccess/").concat(taskId), method: 'get', headers: headers }, options);
};
/**
 * Completes task for specific customer
 * @summary customers/{customerId}/stepsToSuccess/{taskId}/complete
 */
export var createCustomerStepsToSuccessComplete = function (client, customerId, taskId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/stepsToSuccess/").concat(taskId, "/complete"), method: 'post', headers: headers }, options);
};
/**
 * Get subscription configuration
 * @summary customers/{customerId}/subscriptionConfiguration
 */
export var getCustomerSubscriptionConfiguration = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/subscriptionConfiguration"), method: 'get', headers: headers }, options);
};
/**
 * Get subscription availability per specified product/item
 * @summary customers/{customerId}/subscriptionAvailabilities
 */
export var getCustomerSubscriptionAvailabilities = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/subscriptionAvailabilities"), method: 'get', headers: headers, params: params }, options);
};
/**
 * Get subscription types.
Optionally filtered by product contained in subscription.
 * @summary customers/{customerId}/subscriptionTypes
 */
export var getCustomerSubscriptionTypes = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/subscriptionTypes"), method: 'get', headers: headers, params: params }, options);
};
/**
 * Post subscription instruction.
Depends on instruction status (Pending/Finished) provides only validation or also creates new subscription if Finished
 * @summary customers/{customerId}/subscriptionInstructions
 */
export var createCustomerSubscriptionInstruction = function (client, customerId, globalCustomersSubscriptionInstructionDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/subscriptionInstructions"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersSubscriptionInstructionDto,
    }, options);
};
/**
 * Get subscriptions for specified period.
 * @summary customers/{customerId}/subscriptions
 */
export var getCustomerSubscriptions = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/subscriptions"), method: 'get', headers: headers, params: params }, options);
};
/**
 * Cancels an active subscription.
 * @summary customers/{customerId}/subscriptions/{subscriptionId}
 */
export var deleteCustomerSubscription = function (client, customerId, subscriptionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/subscriptions/").concat(subscriptionId), method: 'delete', headers: headers }, options);
};
/**
 * Updates a subscription.
Currently the only legal modification is changing the status from 'Canceled' to 'Reactivated'.
No other modifications are supported at this time.
 * @summary customers/{customerId}/subscriptions/{subscriptionId}
 */
export var updateCustomerSubscription = function (client, customerId, subscriptionId, globalCustomersSubscriptionDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/subscriptions/").concat(subscriptionId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersSubscriptionDto,
    }, options);
};
/**
 * Put subscription item. Currently the only supported change is replacing a subscribed product
by a similar one using the ItemCode property, all other changes will be ignored.
 * @summary customers/{customerId}/subscriptions/{subscriptionId}/subscriptionItems/{subscriptionItemId}
 */
export var updateCustomerSubscriptionSubscriptionItem = function (client, customerId, subscriptionId, subscriptionItemId, globalCustomersSubscriptionItemDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/subscriptions/").concat(subscriptionId, "/subscriptionItems/").concat(subscriptionItemId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersSubscriptionItemDto,
    }, options);
};
/**
 * Get all dropped subscriptions
 * @summary shoppingSessions/{sessionId}/subscriptions
 */
export var getShoppingSessionSubscriptions = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/subscriptions"), method: 'get', headers: headers }, options);
};
/**
 * Get subscription by id
 * @summary shoppingSessions/{sessionId}/subscriptions/{subscriptionId}
 */
export var getShoppingSessionSubscription = function (client, sessionId, subscriptionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/subscriptions/").concat(subscriptionId),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * Cancel (delete) subscription
 * @summary shoppingSessions/{sessionId}/subscriptions/{subscriptionId}
 */
export var deleteShoppingSessionSubscription = function (client, sessionId, subscriptionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/subscriptions/").concat(subscriptionId),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * Get steps of the subscription dropped to the orders
 * @summary shoppingSessions/{sessionId}/subscriptions/{subscriptionId}/steps
 */
export var getShoppingSessionSubscriptionSteps = function (client, sessionId, subscriptionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/subscriptions/").concat(subscriptionId, "/steps"),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * Get subscription step by the step number
 * @summary shoppingSessions/{sessionId}/subscriptions/{subscriptionId}/steps/{stepNumber}
 */
export var getShoppingSessionSubscriptionStep = function (client, sessionId, subscriptionId, stepNumber, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/subscriptions/").concat(subscriptionId, "/steps/").concat(stepNumber),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * Postpone subscription to the next order
 * @summary shoppingSessions/{sessionId}/subscriptions/{subscriptionId}/steps/{stepNumber}
 */
export var deleteShoppingSessionSubscriptionStep = function (client, sessionId, subscriptionId, stepNumber, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/subscriptions/").concat(subscriptionId, "/steps/").concat(stepNumber),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * Postpone subscription to the next order based on cycle and step
 * @summary shoppingSessions/{sessionId}/subscriptions/{subscriptionId}/cycles/{cycleNumber}/steps/{stepNumber}
 */
export var deleteShoppingSessionSubscriptionCycleStep = function (client, sessionId, subscriptionId, cycleNumber, stepNumber, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/subscriptions/").concat(subscriptionId, "/cycles/").concat(cycleNumber, "/steps/").concat(stepNumber),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * GET: Localization for SubscriptionWizard application
 * @summary applications/subscriptionWizard/localization
 */
export var getApplicationsSubscriptionWizardLocalization = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/subscriptionWizard/localization", method: 'get', headers: headers }, options);
};
/**
 * Provides customer downline (only IDs) in a given period. If the period is not specified, the current period is used.
 * @summary commissionPlans/successPlan/customers/{customerId}/downline/onlyId
 */
export var getCommissionPlansSuccessPlanCustomerDownlineOnlyId = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/commissionPlans/successPlan/customers/".concat(customerId, "/downline/onlyId"),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
/**
 * GET: Get shopping bag amounts summary
 * @summary shoppingSessions/{sessionId}/summary
 */
export var getShoppingSessionSummary = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/summary"), method: 'get', headers: headers }, options);
};
/**
 * GET: Get accounts balance before and after shopping
 * @summary shoppingSessions/{sessionId}/summary/accounts
 */
export var getShoppingSessionSummaryAccounts = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/summary/accounts"), method: 'get', headers: headers }, options);
};
/**
 * GET: Get discounts applied to reduce price of the order
 * @summary shoppingSessions/{sessionId}/summary/discounts
 */
export var getShoppingSessionSummaryDiscounts = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/summary/discounts"), method: 'get', headers: headers }, options);
};
/**
 * Gets the categories.
 * @summary applications/supportCenter/categories
 */
export var getApplicationsSupportCenterCategories = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/supportCenter/categories", method: 'get', headers: headers }, options);
};
/**
 * Gets the category by its key.
 * @summary applications/supportCenter/categories/{categoryId}
 */
export var getApplicationsSupportCenterCategory = function (client, categoryId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/supportCenter/categories/".concat(categoryId), method: 'get', headers: headers }, options);
};
/**
 * Gets the localization.
 * @deprecated
 * @summary applications/supportCenter/localization
 */
export var getApplicationsSupportCenterLocalizationDeprecated = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/supportCenter/localization", method: 'get', headers: headers }, options);
};
/**
 * Gets all featured Faqs
 * @summary applications/supportCenter/featuredFaqs
 */
export var getApplicationsSupportCenterFeaturedFaqs = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/supportCenter/featuredFaqs", method: 'get', headers: headers }, options);
};
/**
 * Gets search results
 * @summary applications/supportCenter/search
 */
export var getApplicationsSupportCenterSearch = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/supportCenter/search", method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Provides group tags along with belonging tags.
 * @summary products/tagGroups
 */
export var getProductsTagGroups = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/products/tagGroups", method: 'get', headers: headers }, options);
};
/**
 * GET: Returns documents for tax document
 * @summary customers/{customerId}/taxDocument
 */
export var getCustomerTaxDocument = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/taxDocument"), method: 'get', headers: headers }, options);
};
/**
 * PUT: Change documents for tax document (temporary document are submitted and will no longer be deleted)
 * @summary customers/{customerId}/taxDocument
 */
export var updateCustomerTaxDocument = function (client, customerId, globalCustomersTaxDocumentDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/taxDocument"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersTaxDocumentDto,
    }, options);
};
/**
 * GET: Returns information about customer termination
 * @summary customers/{customerId}/terminationStatus
 */
export var getCustomerTerminationStatus = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/terminationStatus"), method: 'get', headers: headers }, options);
};
/**
 * PUT: Updates information about customer termination
 * @summary customers/{customerId}/terminationStatus
 */
export var updateCustomerTerminationStatus = function (client, customerId, globalCustomersTerminationStatusDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/terminationStatus"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersTerminationStatusDto,
    }, options);
};
/**
 * Returns terms info and html content
 * @deprecated
 * @summary terms/{termId}/html
 */
export var getTermHtmlDeprecated = function (client, termId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/terms/".concat(termId, "/html"), method: 'get', headers: headers }, options);
};
/**
 * @summary test/ping
 */
export var getTestPing = function (client, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/test/ping", method: 'get' }, options);
};
/**
 * GET: Returns data for customer upgrade
 * @summary customers/{customerId}/upgradeRequest
 */
export var getCustomerUpgradeRequest = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/upgradeRequest"), method: 'get', headers: headers }, options);
};
/**
 * PUT: Upgrades VIP customer to consultant.
 * @summary customers/{customerId}/upgradeRequest
 */
export var updateCustomerUpgradeRequest = function (client, customerId, globalUpgradeRequestUpgradeRequestDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/upgradeRequest"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalUpgradeRequestUpgradeRequestDto,
    }, options);
};
/**
 * GET: Returns metadata for customer upgrade process
 * @summary customers/{customerId}/upgradeRequestMetadata
 */
export var getCustomerUpgradeRequestMetadata = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/upgradeRequestMetadata"), method: 'get', headers: headers }, options);
};
/**
 * GET setting for specified customerId and specified business tool Id.
 * @summary businessTools/{businessToolId}/customerSettings/{customerId}
 */
export var getBusinessToolCustomerSetting = function (client, businessToolId, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/businessTools/".concat(businessToolId, "/customerSettings/").concat(customerId),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * DELETE setting for specified business tool / external tool.
 * @summary businessTools/{businessToolId}/customerSettings/{customerId}
 */
export var deleteBusinessToolCustomerSetting = function (client, businessToolId, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/businessTools/".concat(businessToolId, "/customerSettings/").concat(customerId),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * PUT setting for specified customerId and specified business tool Id, allow to store information if tool is activated for customer.
 * @summary businessTools/{businessToolId}/customerSettings/{customerId}
 */
export var updateBusinessToolCustomerSetting = function (client, businessToolId, customerId, globalConsultantsBusinessToolActivationDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/businessTools/".concat(businessToolId, "/customerSettings/").concat(customerId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalConsultantsBusinessToolActivationDto,
    }, options);
};
/**
 * GET settings
 * @summary settingsClients/{settingsClient}/settings/{settingId}/customers/{customerId}
 */
export var getSettingsClientSettingCustomer = function (client, settingsClient, settingId, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/settingsClients/".concat(settingsClient, "/settings/").concat(settingId, "/customers/").concat(customerId),
        method: 'get',
        headers: headers,
    }, options);
};
/**
 * PUT settings
 * @summary settingsClients/{settingsClient}/settings/{settingId}/customers/{customerId}
 */
export var updateSettingsClientSettingCustomer = function (client, settingsClient, settingId, customerId, globalConsultantsSettingDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/settingsClients/".concat(settingsClient, "/settings/").concat(settingId, "/customers/").concat(customerId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalConsultantsSettingDto,
    }, options);
};
/**
 * DELETE settings
 * @summary settingsClients/{settingsClient}/settings/{settingId}/customers/{customerId}
 */
export var deleteSettingsClientSettingCustomer = function (client, settingsClient, settingId, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/settingsClients/".concat(settingsClient, "/settings/").concat(settingId, "/customers/").concat(customerId),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * GET: Returns preferred type of document for VAT
 * @summary customers/{customerId}/vatDocumentType
 */
export var getCustomerVatDocumentType = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/vatDocumentType"), method: 'get', headers: headers }, options);
};
/**
 * PUT: Change preferred type of document for VAT
 * @summary customers/{customerId}/vatDocumentType
 */
export var updateCustomerVatDocumentType = function (client, customerId, globalCustomersCustomerSelectionDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/vatDocumentType"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersCustomerSelectionDtoBody,
    }, options);
};
/**
 * Get video shopping configuration
 * @summary applications/videoShopping/localization
 */
export var getApplicationsVideoShoppingLocalization = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/videoShopping/localization", method: 'get', headers: headers }, options);
};
/**
 * Get video shopping configuration
 * @summary applications/videoShopping/configuration
 */
export var getApplicationsVideoShoppingConfiguration = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/videoShopping/configuration", method: 'get', headers: headers }, options);
};
/**
 * GET: Get video shopping shows for specified user.
 * @summary customers/{customerId}/videoShoppingShows
 */
export var getCustomerVideoShoppingShows = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/videoShoppingShows"), method: 'get', headers: headers, params: params }, options);
};
/**
 * Invites the user to Live video shopping program.
 * @summary customers/{customerId}/videoShoppingInvitation
 */
export var createCustomerVideoShoppingInvitation = function (client, customerId, globalCustomersVideoShoppingUserInvitationDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/videoShoppingInvitation"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersVideoShoppingUserInvitationDto,
    }, options);
};
/**
 * GET - provides content of Vip Customer Banner dependent on whether the customer is Vip End Customer.
 * @summary customers/{customerId}/vipCustomerBanner
 */
export var getCustomerVipCustomerBanner = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/vipCustomerBanner"), method: 'get', headers: headers }, options);
};
/**
 * Get reward steps configuration for VIP customers.
 * @summary vipLoyaltyCampaignStepperConfiguration
 */
export var getVipLoyaltyCampaignStepperConfiguration = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/vipLoyaltyCampaignStepperConfiguration", method: 'get', headers: headers }, options);
};
/**
 * GET: Localization for VipUpgrade application
 * @deprecated
 * @summary applications/vipUpgrade/localization
 */
export var getApplicationsVipUpgradeLocalizationDeprecated = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/vipUpgrade/localization", method: 'get', headers: headers }, options);
};
/**
 * GET: Get list of vouchers entered by customer
 * @summary shoppingSessions/{sessionId}/voucherCodes
 */
export var getShoppingSessionVoucherCodes = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/voucherCodes"), method: 'get', headers: headers }, options);
};
/**
 * DELETE: Remove all vouchers entered by customer
 * @summary shoppingSessions/{sessionId}/voucherCodes
 */
export var deleteShoppingSessionVoucherCodes = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/voucherCodes"), method: 'delete', headers: headers }, options);
};
/**
 * POST: Remove all vouchers entered by customer
 * @summary shoppingSessions/{sessionId}/voucherCodes
 */
export var createShoppingSessionVoucherCode = function (client, sessionId, globalShoppingVoucherCodeDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/voucherCodes"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalShoppingVoucherCodeDto,
    }, options);
};
/**
 * GET: Get voucher entered by customer
 * @summary shoppingSessions/{sessionId}/voucherCodes/{voucherCode}
 */
export var getShoppingSessionVoucherCode = function (client, sessionId, voucherCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/voucherCodes/").concat(voucherCode), method: 'get', headers: headers }, options);
};
/**
 * DELETE: Remove voucher entered by customer
 * @summary shoppingSessions/{sessionId}/voucherCodes/{voucherCode}
 */
export var deleteShoppingSessionVoucherCode = function (client, sessionId, voucherCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/shoppingSessions/".concat(sessionId, "/voucherCodes/").concat(voucherCode),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * GET: Get list of active personal vouchers
 * @summary vouchers
 */
export var getVouchers = function (client, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/vouchers", method: 'get', headers: headers, params: params }, options);
};
/**
 * GET: Get list of vouchers evaluated for current shopping bag
 * @summary shoppingSessions/{sessionId}/vouchers
 */
export var getShoppingSessionVouchers = function (client, sessionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/shoppingSessions/".concat(sessionId, "/vouchers"), method: 'get', headers: headers }, options);
};
/**
 * GET: Localization for Vouchers application
 * @summary applications/vouchers/localization
 */
export var getApplicationsVouchersLocalization = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/vouchers/localization", method: 'get', headers: headers }, options);
};
/**
 * Returns wallet report
 * @summary customers/{customerId}/walletReport
 */
export var getCustomerWalletReport = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/walletReport"), method: 'get', headers: headers }, options);
};
/**
 * User update webook event from bambuser system.
 * @summary applications/videoShopping/accounts/{accountId}/userEvents
 */
export var createApplicationsVideoShoppingAccountUserEvent = function (client, accountId, globalApplicationsVideoShoppingUserEventDto, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/applications/videoShopping/accounts/".concat(accountId, "/userEvents"),
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        data: globalApplicationsVideoShoppingUserEventDto,
    }, options);
};
/**
 * Creates new WeChat external account
 * @summary login/providers/weChat/externalAccount
 */
export var createLoginProvidersWeChatExternalAccount = function (client, globalLoginWeChatAccountDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/login/providers/weChat/externalAccount",
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalLoginWeChatAccountDto,
    }, options);
};
/**
 * Provides collection of connected WeChat platform by unionId
 * @summary login/providers/weChat/externalAccount/{unionId}/platforms
 */
export var getLoginProvidersWeChatExternalAccountPlatforms = function (client, unionId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/login/providers/weChat/externalAccount/".concat(unionId, "/platforms"), method: 'get', headers: headers }, options);
};
/**
 * Add new platform to specific WeChat
 * @summary login/providers/weChat/externalAccount/{unionId}/platforms
 */
export var createLoginProvidersWeChatExternalAccountPlatform = function (client, unionId, globalLoginProvidersWeChatPlatformDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/login/providers/weChat/externalAccount/".concat(unionId, "/platforms"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalLoginProvidersWeChatPlatformDto,
    }, options);
};
/**
 * Get all wellness club managed by specified customer base on query parameter.
In case that isMember is False then wellness club where customerId is owner will be returned.
Otherwise wellness club where customerId is member will be returned.
 * @summary customers/{customerId}/wellnessClubs
 */
export var getCustomerWellnessClubs = function (client, customerId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/wellnessClubs"), method: 'get', headers: headers, params: params }, options);
};
/**
 * Create wellness club.
 * @summary customers/{customerId}/wellnessClubTypes/{clubType}/wellnessClubs
 */
export var createCustomerWellnessClubTypeWellnessClub = function (client, customerId, clubType, globalCustomersWellnessClubDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/wellnessClubTypes/").concat(clubType, "/wellnessClubs"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersWellnessClubDto,
    }, options);
};
/**
 * Get Wellness club base on type and club id.
 * @summary customers/{customerId}/wellnessClubTypes/{clubType}/wellnessClubs/{clubId}
 */
export var getCustomerWellnessClubTypeWellnessClub = function (client, customerId, clubType, clubId, params, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/wellnessClubTypes/").concat(clubType, "/wellnessClubs/").concat(clubId),
        method: 'get',
        headers: headers,
        params: params,
    }, options);
};
/**
 * Update specified Wellness club.
 * @summary customers/{customerId}/wellnessClubTypes/{clubType}/wellnessClubs/{clubId}
 */
export var updateCustomerWellnessClubTypeWellnessClub = function (client, customerId, clubType, clubId, globalCustomersWellnessClubDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/wellnessClubTypes/").concat(clubType, "/wellnessClubs/").concat(clubId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersWellnessClubDto,
    }, options);
};
/**
 * Delete specified Wellness club.
 * @summary customers/{customerId}/wellnessClubTypes/{clubType}/wellnessClubs/{clubId}
 */
export var deleteCustomerWellnessClubTypeWellnessClub = function (client, customerId, clubType, clubId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/wellnessClubTypes/").concat(clubType, "/wellnessClubs/").concat(clubId),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * Add one customer as a club member to club specified by club id.
 * @summary customers/{customerId}/wellnessClubTypes/{clubType}/wellnessClubs/{clubId}/members
 */
export var createCustomerWellnessClubTypeWellnessClubMember = function (client, customerId, clubType, clubId, globalCustomersWellnessClubMemberDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/wellnessClubTypes/").concat(clubType, "/wellnessClubs/").concat(clubId, "/members"),
        method: 'post',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersWellnessClubMemberDtoBody,
    }, options);
};
/**
 * Delete one member specified by it's customer id from a club specified by it's club id.
 * @summary customers/{customerId}/wellnessClubTypes/{clubType}/wellnessClubs/{clubId}/members/{memberCustomerId}
 */
export var deleteCustomerWellnessClubTypeWellnessClubMember = function (client, customerId, clubType, clubId, memberCustomerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/wellnessClubTypes/").concat(clubType, "/wellnessClubs/").concat(clubId, "/members/").concat(memberCustomerId),
        method: 'delete',
        headers: headers,
    }, options);
};
/**
 * Update club membership of specified member customer id nad specified by club id.
 * @summary customers/{customerId}/wellnessClubTypes/{clubType}/wellnessClubs/{clubId}/members/{memberCustomerId}
 */
export var updateCustomerWellnessClubTypeWellnessClubMember = function (client, customerId, clubType, clubId, memberCustomerId, globalCustomersWellnessClubMemberDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/wellnessClubTypes/").concat(clubType, "/wellnessClubs/").concat(clubId, "/members/").concat(memberCustomerId),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersWellnessClubMemberDtoBody,
    }, options);
};
/**
 * Approve or reject of wellness club invitation.
 * @summary wellnessClubInvitations/{invitationCode}/approval
 */
export var updateWellnessClubInvitationApproval = function (client, invitationCode, globalCustomersWellnessClubInvitationApprovalDto, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/wellnessClubInvitations/".concat(invitationCode, "/approval"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersWellnessClubInvitationApprovalDto,
    }, options);
};
/**
 * Get wellness club information base on invitation code.
 * @summary wellnessClubInvitations/{invitationCode}/details
 */
export var getWellnessClubInvitationDetails = function (client, invitationCode, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/wellnessClubInvitations/".concat(invitationCode, "/details"), method: 'get', headers: headers }, options);
};
/**
 * Get wellness club configuration
 * @summary applications/wellnessClub/localization
 */
export var getApplicationsWellnessClubLocalization = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/wellnessClub/localization", method: 'get', headers: headers }, options);
};
/**
 * Get wellnes club configuration
 * @summary applications/wellnessClub/configuration
 */
export var getApplicationsWellnessClubConfiguration = function (client, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/applications/wellnessClub/configuration", method: 'get', headers: headers }, options);
};
/**
 * GET: Returns information about wellness life for given customer
 * @summary customers/{customerId}/wellnessLife
 */
export var getCustomerWellnessLife = function (client, customerId, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({ url: "/customers/".concat(customerId, "/wellnessLife"), method: 'get', headers: headers }, options);
};
/**
 * PUT: Change wellness life approval flag
 * @summary customers/{customerId}/wellnessLife
 */
export var updateCustomerWellnessLife = function (client, customerId, globalCustomersCustomerBooleanDtoBody, headers, options) {
    var customInstance = client.createFetcher();
    return customInstance({
        url: "/customers/".concat(customerId, "/wellnessLife"),
        method: 'put',
        headers: __assign({ 'Content-Type': 'application/json' }, headers),
        data: globalCustomersCustomerBooleanDtoBody,
    }, options);
};

//# sourceMappingURL=api.js.map
